"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8895],{

/***/ 1725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgClose = function SvgClose(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        viewBox: "0 0 14 14"
    }, props), _g || (_g = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "m1.375 12.625 11.25-11.25M12.625 12.625 1.375 1.374"
    }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgClose);


/***/ }),

/***/ 32184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useInterval; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useInterval(callback, delay) {
    var deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var intervalRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (delay === null || delay === 0) {
            if (intervalRef.current) {
                window.clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            return;
        }
        var tick = function() {
            return savedCallback.current();
        };
        if (typeof delay === "number") {
            intervalRef.current = window.setInterval(tick, delay);
            return function() {
                return window.clearInterval(intervalRef.current);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(deps).concat([
        delay
    ]));
    return intervalRef;
}


/***/ }),

/***/ 96339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ currentSmallerThanFinalDate; },
/* harmony export */   "jB": function() { return /* binding */ fireHotjarEventScript; },
/* harmony export */   "no": function() { return /* binding */ fireHotjarEvents; }
/* harmony export */ });
/* unused harmony export fireHotjarEvent */
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64487);

var fireHotjarEventScript = function(eventName) {
    return '(function(w){\n        if(!hj) return;\n        w.hj("event","'.concat(eventName, '");\n    })(window)');
};
var fireHotjarEvent = function(eventName) {
    try {
        if (window.hj) {
            window.hj("event", eventName);
        }
    } catch (e) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb(e);
    }
};
// fires a list of events to Hotjar
var fireHotjarEvents = function(eventNames) {
    // have only unique values
    var uniqueEventNames = eventNames.filter(function(element, index, array) {
        return array.indexOf(element) === index;
    });
    // fire each event, so filtering can be fully customized on Hotjar side
    uniqueEventNames.forEach(function(uniqueEventName) {
        return fireHotjarEvent(uniqueEventName);
    });
};
var currentSmallerThanFinalDate = function(hotjarFinalDate) {
    var currentDate = new Date();
    var finalDate = new Date(hotjarFinalDate);
    return currentDate.getTime() <= finalDate.getTime();
};


/***/ }),

/***/ 95929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getAppIconsLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var getAppIconsLinks = function() {
    return [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "shortcut icon",
            href: "/static/img/favicons/favicon.ico"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            sizes: "16x16 32x32 64x64",
            href: "/static/img/favicons/favicon.ico"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            type: "image/png",
            sizes: "196x196",
            href: "/static/img/favicons/favicon-monday5-192.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            type: "image/png",
            sizes: "96x96",
            href: "/static/img/favicons/favicon-monday5-96.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            type: "image/png",
            sizes: "64x64",
            href: "/static/img/favicons/favicon-monday5-60.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            type: "image/png",
            sizes: "32x32",
            href: "/static/img/favicons/favicon-monday5-32.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            type: "image/png",
            sizes: "16x16",
            href: "/static/img/favicons/favicon-monday5-16.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            href: "/static/img/favicons/favicon-monday5-57.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "114x114",
            href: "/static/img/favicons/favicon-monday5-114.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "72x72",
            href: "/static/img/favicons/favicon-monday5-72.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "144x144",
            href: "/static/img/favicons/favicon-monday5-144.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "60x60",
            href: "/static/img/favicons/favicon-monday5-60.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "120x120",
            href: "/static/img/favicons/favicon-monday5-120.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "76x76",
            href: "/static/img/favicons/favicon-monday5-76.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "152x152",
            href: "/static/img/favicons/favicon-monday5-152.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "apple-touch-icon",
            sizes: "180x180",
            href: "/static/img/favicons/favicon-monday5-180.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "msapplication-TileColor",
            content: "#FFFFFF"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "msapplication-TileImage",
            content: "/static/img/favicons/favicon-monday5-144.png"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "icon",
            type: "image/x-icon",
            href: "/static/img/favicons/favicon.ico"
        })
    ];
};


/***/ }),

/***/ 20525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TabComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/tabs/tab/tab-component.scss.js

var LINE_WIDTH = 4;
var LINE_WIDTH_STRING = "".concat(LINE_WIDTH, "px");
var StyledTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ergyzlu0"
})("position:relative;text-align:center;min-width:240px;cursor:pointer;padding:16px 24px;:hover{outline:0;background-color:var(--tab-background-color);.tab-label{color:var(--tab-color);}}&.active{background-color:var(--tab-background-color);.tab-underline-placeholder{background:var(--tab-background-color);.tab-underline{left:0;right:0;}}}&.small-labels{min-width:160px;.tab-label{font-size:0.875rem;}}&.half-screen-tabs{min-width:100px;display:flex;justify-content:center;padding:8px 5px;.title-wrapper{.title-and-icon-wrapper{.core-title-container .core-title{font-weight:300;}.icon-wrapper{.picture-icon-wrapper{height:20px;margin-bottom:4px;}}}}}.tab-label{font-weight:600;font-size:1.375rem;}.tab-underline-placeholder{position:absolute;height:", LINE_WIDTH_STRING, ";bottom:0;left:0;right:0;border-top-left-radius:", LINE_WIDTH_STRING, ";border-top-right-radius:", LINE_WIDTH_STRING, ";.tab-underline{position:absolute;top:0;bottom:0;left:50%;right:50%;transition:left 0.2s ease,right 0.2s ease;border-top-left-radius:", LINE_WIDTH_STRING, ";border-top-right-radius:", LINE_WIDTH_STRING, ";}}");

;// CONCATENATED MODULE: ./components/core/tabs/tab/tab-component.js






function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}











var TabComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TabComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TabComponent);
    function TabComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TabComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "blurTab", function(e) {
            var _e_target_closest, _e_target;
            e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_closest = _e_target.closest(".tab-component")) === null || _e_target_closest === void 0 ? void 0 : _e_target_closest.blur();
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "tabClickedAction", function() {
            var _props = _this.props, onClick = _props.onClick, index = _props.index, label = _props.label, labelTranslationKey = _props.labelTranslationKey, extraData = _props.extraData;
            BigBrain("track", bigbrain_event_types.TAB_CLICKED, {
                kind: label,
                info1: index,
                info2: labelTranslationKey,
                data: extraData
            });
            onClick(index);
        });
        _this.onTabClicked = _this.onTabClicked.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.tabClickedAction);
        return _this;
    }
    (0,_create_class/* default */.Z)(TabComponent, [
        {
            key: "onTabClicked",
            value: function onTabClicked(e) {
                this.blurTab(e);
                this.tabClickedAction();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, label = _props.label, hideLabel = _props.hideLabel, color = _props.color, backgroundColor = _props.backgroundColor, isActive = _props.isActive, useSmallLabels = _props.useSmallLabels, tabIcon = _props.tabIcon, useXSMLabels = _props.useXSMLabels, tabsWithIcons = _props.tabsWithIcons, tabClassName = _props.tabClassName, theme = _props.theme, unsetLabelColor = _props.unsetLabelColor;
                var tabColor = colors/* default */.Z[color];
                var tabLabel = hideLabel ? "" : label;
                var defaultTabLabelColor = (0,segments_service/* isDarkTheme */.$o)(theme) ? colors/* default */.Z[color_consts.WHITE_COLOR_NAME] : colors/* default.mud */.Z.mud;
                var tabLabelColor = isActive ? tabColor : defaultTabLabelColor;
                var unsetTabLabelcolor = function() {
                    return unsetLabelColor && (0,segments_service/* isDarkTheme */.$o)(theme) && !isActive;
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabComponent, {
                    className: classnames_default()("tab-component", (0,_define_property/* default */.Z)({
                        active: isActive,
                        "small-labels": useSmallLabels,
                        "half-screen-tabs": useXSMLabels
                    }, tabClassName, tabClassName)),
                    style: {
                        "--tab-color": tabColor,
                        "--tab-background-color": colors/* default */.Z[backgroundColor] || colors/* default */.Z[color_consts.BACKGROUND_GRAY_COLOR_NAME]
                    },
                    onClick: this.onTabClicked,
                    role: "tab",
                    "aria-selected": isActive,
                    tabIndex: 0,
                    onKeyDown: this.onKeyDown,
                    children: [
                        !tabsWithIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tab-label",
                            style: unsetTabLabelcolor() ? {} : {
                                color: tabLabelColor
                            },
                            children: tabLabel
                        }),
                        tabsWithIcons && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                title: tabLabel,
                                titleIcon: tabIcon === null || tabIcon === void 0 ? void 0 : tabIcon.src,
                                titleSize: sizes/* XS_L */.L4
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tab-underline-placeholder",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tab-underline",
                                style: {
                                    background: tabColor
                                }
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return TabComponent;
}(react.PureComponent);

TabComponent.defaultProps = {
    useSmallLabels: false
};


/***/ }),

/***/ 10873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./node_modules/querystring/index.js
var querystring = __webpack_require__(17673);
// EXTERNAL MODULE: ./constants/query-params.js
var query_params = __webpack_require__(54224);
// EXTERNAL MODULE: ./client/services/hooks/use-interval.js
var use_interval = __webpack_require__(32184);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/tabs/tabs-component.scss.js

var StyledTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "edmslg20"
})("display:flex;flex-direction:column;&.left{align-items:flex-start;}&.center{align-items:center;}&.right{align-items:flex-end;}.tabs{display:flex;width:100%;justify-content:space-around;}.content{padding-top:48px;}");

;// CONCATENATED MODULE: ./components/core/tabs/tabs-component.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}










var TabsComponent = function(props) {
    var children = props.children, defaultActiveTabIndex = props.defaultActiveTabIndex, router = props.router, autoTransition = props.autoTransition, className = props.className, tabsAlign = props.tabsAlign, scrollSpeed = props.scrollSpeed, scrollOnTabClick = props.scrollOnTabClick, distanceFromTop = props.distanceFromTop, onTabClick = props.onTabClick;
    var getInitialActiveTabIndex = function() {
        try {
            var _router_asPath_split, _router_asPath;
            var params = querystring.parse(router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : (_router_asPath_split = _router_asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[1]);
            var activeTabId = params === null || params === void 0 ? void 0 : params[query_params.ACTIVE_TAB_ID];
            if (activeTabId) {
                var activeTabIndexById = children === null || children === void 0 ? void 0 : children.findIndex(function(tab) {
                    var _tab_props;
                    return (tab === null || tab === void 0 ? void 0 : (_tab_props = tab.props) === null || _tab_props === void 0 ? void 0 : _tab_props.tabId) === activeTabId;
                });
                if (activeTabIndexById && activeTabIndexById >= 0) {
                    return activeTabIndexById;
                }
            }
        } catch (e) {
            return defaultActiveTabIndex;
        }
        return defaultActiveTabIndex;
    };
    var ref = (0,react.useState)(getInitialActiveTabIndex()), activeTabIndex = ref[0], setActiveTabIndex = ref[1];
    var contentNode = (0,react.useRef)();
    var autoTransitionAsNumber = Number(autoTransition || 0);
    (0,use_interval/* default */.Z)(function() {
        setActiveTabIndex((activeTabIndex + 1) % children.length);
    }, autoTransitionAsNumber > 0 ? autoTransitionAsNumber : null, [
        activeTabIndex
    ]);
    var handleTabClick = function() {
        var _ref = _async_to_generator(function(index) {
            var node, _tmp, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        node = contentNode === null || contentNode === void 0 ? void 0 : contentNode.current;
                        if (onTabClick) {
                            onTabClick(index);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        _tmp = scrollOnTabClick && node;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            (0,dom_utils_service.isNodeFullyInView)(node)
                        ];
                    case 2:
                        _tmp = !_state.sent();
                        _state.label = 3;
                    case 3:
                        if (_tmp) {
                            (0,dom_utils_service.scrollTo)(contentNode.current.offsetTop - distanceFromTop, scrollSpeed);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setActiveTabIndex(index);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleTabClick(index) {
            return _ref.apply(this, arguments);
        };
    }();
    var tabsRenderer = function() {
        return children.map(function(child, index) {
            return /*#__PURE__*/ (0,react.cloneElement)(child, {
                onClick: handleTabClick,
                index: index,
                isActive: index === activeTabIndex
            });
        });
    };
    var contentRenderer = function() {
        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabsComponent, {
        className: classnames_default()("tabs-component", className, tabsAlign),
        ref: contentNode,
        role: "tablist",
        "aria-label": "documentation-navigation",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tabs",
                style: {
                    "--tab-transition": autoTransition
                },
                children: tabsRenderer()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content",
                role: "tab",
                children: contentRenderer()
            })
        ]
    });
};
/* harmony default export */ var tabs_component = ((0,router.withRouter)(TabsComponent));
TabsComponent.defaultProps = {
    children: [],
    defaultActiveTabIndex: 0,
    autoTransition: "30000",
    scrollSpeed: 200,
    scrollOnTabClick: false,
    distanceFromTop: 0,
    className: "",
    tabsAlign: align_types.ALIGN_TYPES.CENTER
};


/***/ }),

/***/ 38895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./components/core/head/google-structured-data/google-structured-data.js
var google_structured_data = __webpack_require__(98016);
// EXTERNAL MODULE: ./constants/localization.js
var localization = __webpack_require__(72632);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./components/core/head/first-fold-images.js

var FirstFoldImages = function(preloadFirstFoldImages) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: preloadFirstFoldImages === null || preloadFirstFoldImages === void 0 ? void 0 : preloadFirstFoldImages.map(function(image, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preload",
                href: image === null || image === void 0 ? void 0 : image.src,
                as: "image"
            }, "".concat(image === null || image === void 0 ? void 0 : image.src).concat(index));
        })
    });
};
/* harmony default export */ var first_fold_images = (FirstFoldImages);

// EXTERNAL MODULE: ./constants/templates-names.js
var templates_names = __webpack_require__(35015);
;// CONCATENATED MODULE: ./components/core/head/meta-tags.js


var NO_INDEX_STRING = "noindex";
var INDEX_STRING = "index";
var NO_FOLLOW_STRING = "nofollow";
var FOLLOW_STRING = "follow";
var NO_INDEX_LP_TEMPLATES = [
    templates_names.TEMPLATE_NAMES.OnePagerAssetTemplate,
    templates_names.TEMPLATE_NAMES.OnePagerWithImageTemplate,
    templates_names.TEMPLATE_NAMES.MobileOnePagerWithImageTemplate,
    templates_names.TEMPLATE_NAMES.OnePagerWithVideoTemplate,
    templates_names.TEMPLATE_NAMES.CompetitorTemplate
];
var isProduction = "production" === "production";
var getMetaTags = function(param) {
    var template = param.template, noIndex = param.noIndex, noFollow = param.noFollow;
    var shouldNoIndexOrNoFollow = function() {
        if (noIndex || noFollow) return true;
        return NO_INDEX_LP_TEMPLATES.includes(template);
    };
    var getRobotsContentText = function() {
        var indexStr = noIndex ? NO_INDEX_STRING : INDEX_STRING;
        var followStr = noFollow ? NO_FOLLOW_STRING : FOLLOW_STRING;
        return "".concat(indexStr, ", ").concat(followStr);
    };
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            httpEquiv: "x-ua-compatible",
            content: "ie=edge"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1.0"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "theme-color",
            content: "#333333"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "msapplication-navbutton-color",
            content: "#333333"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "coverage",
            content: "Worldwide"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "distribution",
            content: "Global"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "rating",
            content: "General"
        }),
        isProduction && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "facebook-domain-verification",
            content: "fp63743zc2gqopx7ds8uyh9aplxwa3"
        }),
        shouldNoIndexOrNoFollow() && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "robots",
            content: getRobotsContentText()
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
            rel: "sitemap",
            type: "application/xml",
            title: "Sitemap",
            href: "/sitemap.xml"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "p:domain_verify",
            content: "b23b9536c7fb460593afc0a4efb90c3f"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "google-site-verification",
            content: "_um4GXuRDHUpvGCATPKd3z0pZFISWfjidYVj47c0bhA"
        })
    ];
};

// EXTERNAL MODULE: ./components/core/head/app-icons.js
var app_icons = __webpack_require__(95929);
;// CONCATENATED MODULE: ./components/core/head/social-meta-tags/facebook-meta.js

var MONDAY_BASE_PATH = "https://monday.com";
var getFacebookMetaTags = function(param) {
    var title = param.title, description = param.description, pagePath = param.pagePath, _imagePath = param.imagePath, imagePath = _imagePath === void 0 ? "https://s3.amazonaws.com/general-assets/monday-1200x628.png" : _imagePath, _imageType = param.imageType, imageType = _imageType === void 0 ? "image/png" : _imageType, _imageWidth = param.imageWidth, imageWidth = _imageWidth === void 0 ? "1200" : _imageWidth, _imageHeight = param.imageHeight, imageHeight = _imageHeight === void 0 ? "628" : _imageHeight;
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:title",
            content: title
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:type",
            content: "website"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:url",
            content: "".concat(MONDAY_BASE_PATH).concat(pagePath)
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:description",
            content: description
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:site_name",
            content: "monday.com"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image",
            content: imagePath
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image:type",
            content: imageType
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image:width",
            content: imageWidth
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "og:image:height",
            content: imageHeight
        })
    ];
};

;// CONCATENATED MODULE: ./components/core/head/social-meta-tags/twitter-meta.js

var TWITTER_USER_ID = "912574397076123648";
var getTwitterMetaTags = function(param) {
    var title = param.title, description = param.description, _imagePath = param.imagePath, imagePath = _imagePath === void 0 ? "https://s3.amazonaws.com/general-assets/monday-800x418.png" : _imagePath;
    return [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:card",
            content: "summary"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:site",
            content: "@mondaydotcom"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:title",
            content: title
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:description",
            content: description
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            name: "twitter:image",
            content: imagePath
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
            property: "twitter:account_id",
            content: TWITTER_USER_ID
        })
    ];
};

// EXTERNAL MODULE: ./components/core/head/fonts-component.js
var fonts_component = __webpack_require__(11094);
// EXTERNAL MODULE: ./components/core/google-tag-manager/google-tag-manager-component.js
var google_tag_manager_component = __webpack_require__(54172);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/monday-platform/existing-accounts-service.js
var existing_accounts_service = __webpack_require__(14124);
;// CONCATENATED MODULE: ./utils/inline-scripts.js


var cookieValueByNameInlineScript = "\n		const cookieValueByName = cookieName => {\n			if (!cookieName) return null;\n			var b = document.cookie.match('(^|;)\\\\s*' + cookieName + '\\\\s*=\\\\s*([^;]+)');\n			return b ? b.pop() : null;\n		}\n";
var setCookieInlineScript = '\n		const setCookie = (name, value, exdays) => {\n				const d = new Date();\n				d.setTime(d.getTime() + (exdays*24*60*60*1000));\n				var expires = "expires="+ d.toUTCString();\n				document.cookie = name + "=" + value + ";" + expires + ";domain='.concat(cookies.COOKIES_DOMAIN, ';path=/";\n		}\n');
var shouldRecordFromDrawInlineScript = "\n		const shouldRecordFromDraw = (recordEveryNth) => {\n		if (!recordEveryNth) return false;\n			return Math.ceil(Math.random() * recordEveryNth) === recordEveryNth;\n		}\n";
var bigBrainTrackEventInlineScript = '\n		const trackBigbrainEvent = (eventName, eventParams={}) => {\n		if (window.BigBrain) {\n			window.BigBrain("track", eventName, eventParams);\n			}\n		}\n';
var getSlugDataInlineScript = "\n		".concat(cookieValueByNameInlineScript, '\n		const onlyNewFirstUserSlug = (date) => {\n			try {\n				let slugsFromCookie = cookieValueByName("').concat(existing_accounts_service/* SLUG_DETAILS_COOKIE_NAME */.tV, '");\n				let slugs = [];\n				if (slugsFromCookie) {\n					slugsFromCookie = decodeURIComponent(slugsFromCookie);\n					slugs = JSON.parse(slugsFromCookie);\n				}\n				const newSlugs = slugs.filter((slug) => slug.ac && new Date(slug.ac) >= date && slug.us === 1);\n				return slugs.length > 0 && newSlugs.length === slugs.length;\n			}\n			catch {\n				return false\n			}\n		}\n');

;// CONCATENATED MODULE: ./components/core/head/redirect-to-platform-script/redirect-to-platform-script.js




var platformDomain = "monday.com";
var RedirectToPlatfromScript = function(param) {
    var persistantCookies = param.persistantCookies;
    var redirectToPlatformPricingIfNotPayingAccount = function() {
        if ((0,existing_accounts_service/* isExistingNonPayingAccount */.LM)(persistantCookies)) {
            // else we're not redirecting and not overriding appUrl
            return '\n          const platformPricingUrl = "//"+lastActiveSlug + ".'.concat(platformDomain, '/pricing_page";\n          window.location.replace(platformPricingUrl);\n      ');
        }
        return " // do nothing - not in redirect variant ";
    };
    var redirectToPlatformIfNeeded = function() {
        return "\n        ".concat(getSlugDataInlineScript, "\n        const lastActiveSlug = cookieValueByName('").concat(cookies.LAST_ACCOUNT_SLUG, "');  // cookieValueByName defined inside getSlugDataInlineScript\n \n        const preventRedirect = window.location.search.indexOf('no-redirect') > 0;\n\n        if(lastActiveSlug && !preventRedirect) {\n          var appUrl = \"//\"+lastActiveSlug + \".").concat(platformDomain, '";\n          var path = window.location.pathname.trim();;\n\n          const isPricingPage = path.includes("pricing");\n          if (isPricingPage) {\n            ').concat(redirectToPlatformPricingIfNotPayingAccount(), "\n          }\n          else {\n            window.location.replace(appUrl);\n          }\n        }\n    ");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        dangerouslySetInnerHTML: {
            __html: redirectToPlatformIfNeeded()
        }
    });
};
/* harmony default export */ var redirect_to_platform_script = (RedirectToPlatfromScript);

// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./components/core/head/signup-prefetched-assets-links-component.js
var signup_prefetched_assets_links_component = __webpack_require__(40221);
// EXTERNAL MODULE: ./components/core/head/faq-seo/faq-seo.js
var faq_seo = __webpack_require__(28069);
// EXTERNAL MODULE: ./constants/prefetch-constants.js
var prefetch_constants = __webpack_require__(83139);
// EXTERNAL MODULE: ./constants/typeform-contact-sales.js
var typeform_contact_sales = __webpack_require__(13979);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
;// CONCATENATED MODULE: ./client/services/typeform/prefetch-typeform-service.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var TYPEFORM_FONT_CSS_FILE = "https://font.typeform.com/dist/google/roboto/index.css";
var TYPEFORM_ROBOTO_400_FONT = "https://font.typeform.com/dist/google/roboto/files/roboto-latin-400-normal.woff2";
var TYPEFORM_ROBOTO_700_FONT = "https://font.typeform.com/dist/google/roboto/files/roboto-latin-700-normal.woff2";
var MONDAY_LOGO = "https://images.typeform.com/images/2GR8rmBChTYm";
var STATIC_ASSETS_HREFS = [
    TYPEFORM_FONT_CSS_FILE,
    TYPEFORM_ROBOTO_400_FONT,
    TYPEFORM_ROBOTO_700_FONT,
    MONDAY_LOGO
];
var PREFETCHED_DOMAINS = [
    "https://form.typeform.com"
];
var PRECONNECT_DOMAINS = PREFETCHED_DOMAINS;
var PrefetchedTypeformAssetsContext = /*#__PURE__*/ (0,react.createContext)("PrefetchedTypeformAssets");
var PrefetchTypeformAssetsProvider = function(props) {
    var children = props.children, cloudfrontViewerCountry = props.cloudfrontViewerCountry, useNewTypeformUSVariant = props.useNewTypeformUSVariant, abTests = props.abTests;
    var ref = (0,react.useState)([]), prefetchedTypeformAssetsLinks = ref[0], setPrefetchedTypeformAssetsLinks = ref[1];
    var getNewVariantForTest = useNewTypeformUSVariant || (0,acquisition_ab_test_service.shouldUseNewTypeformVariant)(abTests);
    (0,react.useEffect)(function() {
        var setData = function() {
            var _ref = _async_to_generator(function() {
                var typeformAssetsLinks, dynamicAssets;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    typeformAssetsLinks = [];
                    // dns prefetches
                    PREFETCHED_DOMAINS.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants/* PREFETCH_TYPES.DNS_PREFETCH */.DO.DNS_PREFETCH,
                            href: href
                        });
                    });
                    // pre-connects
                    PRECONNECT_DOMAINS.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants/* PREFETCH_TYPES.PRECONNECT */.DO.PRECONNECT,
                            href: href
                        });
                    });
                    // static assets
                    STATIC_ASSETS_HREFS.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants/* PREFETCH_TYPES.PREFETCH */.DO.PREFETCH,
                            href: href
                        });
                    });
                    dynamicAssets = (0,typeform_contact_sales/* getTypeformImagesPrefetchByCountry */.Ks)(cloudfrontViewerCountry, getNewVariantForTest);
                    dynamicAssets && dynamicAssets.forEach(function(href) {
                        typeformAssetsLinks.push({
                            type: prefetch_constants/* PREFETCH_TYPES.PREFETCH */.DO.PREFETCH,
                            href: href
                        });
                    });
                    setPrefetchedTypeformAssetsLinks(typeformAssetsLinks);
                    return [
                        2
                    ];
                });
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, [
        cloudfrontViewerCountry
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchedTypeformAssetsContext.Provider, {
        value: prefetchedTypeformAssetsLinks,
        children: children
    });
};
var prefetch_typeform_service_usePrefetchedTypeformAssets = function() {
    var prefetchedTypeformAssetsLinks = useContext(PrefetchedTypeformAssetsContext);
    return prefetchedTypeformAssetsLinks;
};

;// CONCATENATED MODULE: ./components/core/head/typeform-prefetched-assets-links-component.js



var TypeformPrefetchedAssetsLinksComponent = function() {
    var allPrefetchedAssets = usePrefetchedTypeformAssets();
    var dnsPrefetchedDomains = allPrefetchedAssets && allPrefetchedAssets.filter(function(asset) {
        return asset.type === PREFETCH_TYPES.DNS_PREFETCH;
    });
    var preConnectedDomains = allPrefetchedAssets && (allPrefetchedAssets === null || allPrefetchedAssets === void 0 ? void 0 : allPrefetchedAssets.filter(function(asset) {
        return asset.type === PREFETCH_TYPES.PRECONNECT;
    }));
    var prefetchedAssets = allPrefetchedAssets && (allPrefetchedAssets === null || allPrefetchedAssets === void 0 ? void 0 : allPrefetchedAssets.filter(function(asset) {
        return asset.type === PREFETCH_TYPES.PREFETCH;
    }));
    var PREFETCHED_LINK_ID = function(index) {
        return "typeform_prefetched_link_".concat(index);
    };
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map(function(prefetchedDomain, index) {
            return /*#__PURE__*/ _jsx("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index);
        }),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map(function(preConnectedDomain) {
            return /*#__PURE__*/ _jsx("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            });
        }),
        prefetchedAssets === null || prefetchedAssets === void 0 ? void 0 : prefetchedAssets.map(function(prefetchedAsset, index) {
            return /*#__PURE__*/ _jsx("link", {
                id: PREFETCHED_LINK_ID(index),
                rel: prefetchedAsset.type,
                href: prefetchedAsset.href
            });
        })
    ];
};
/* harmony default export */ var typeform_prefetched_assets_links_component = ((/* unused pure expression or super */ null && (TypeformPrefetchedAssetsLinksComponent)));

;// CONCATENATED MODULE: ./client/services/live-board/prefetch-liveboard-service.js

function prefetch_liveboard_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function prefetch_liveboard_service_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                prefetch_liveboard_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                prefetch_liveboard_service_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var prefetch_liveboard_service_PREFETCHED_DOMAINS = [
    "https://views.monday.com"
];
var prefetch_liveboard_service_PRECONNECT_DOMAINS = prefetch_liveboard_service_PREFETCHED_DOMAINS;
var PrefetchedLiveBoardAssetsContext = /*#__PURE__*/ (0,react.createContext)("PrefetchedLiveBoardAssets");
var PrefetchLiveBoardAssetsProvider = function(props) {
    var children = props.children;
    var ref = (0,react.useState)([]), prefetchedLiveBoardAssetsLinks = ref[0], setPrefetchedLiveBoardAssetsLinks = ref[1];
    (0,react.useEffect)(function() {
        var setData = function() {
            var _ref = prefetch_liveboard_service_async_to_generator(function() {
                var LiveBoardAssetsLinks;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    LiveBoardAssetsLinks = [];
                    // dns prefetches
                    prefetch_liveboard_service_PREFETCHED_DOMAINS.forEach(function(href) {
                        LiveBoardAssetsLinks.push({
                            type: prefetch_constants/* PREFETCH_TYPES.DNS_PREFETCH */.DO.DNS_PREFETCH,
                            href: href
                        });
                    });
                    // pre-connects
                    prefetch_liveboard_service_PRECONNECT_DOMAINS.forEach(function(href) {
                        LiveBoardAssetsLinks.push({
                            type: prefetch_constants/* PREFETCH_TYPES.PRECONNECT */.DO.PRECONNECT,
                            href: href
                        });
                    });
                    setPrefetchedLiveBoardAssetsLinks(LiveBoardAssetsLinks);
                    return [
                        2
                    ];
                });
            });
            return function setData() {
                return _ref.apply(this, arguments);
            };
        }();
        setData();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchedLiveBoardAssetsContext.Provider, {
        value: prefetchedLiveBoardAssetsLinks,
        children: children
    });
};
var usePrefetchedLiveBoardAssets = function() {
    var prefetchedLiveBoardAssetsLinks = (0,react.useContext)(PrefetchedLiveBoardAssetsContext);
    return prefetchedLiveBoardAssetsLinks;
};

;// CONCATENATED MODULE: ./components/core/head/liveboard-prefetched-assets-links-component.js



var LiveBoardPrefetchedAssetsLinksComponent = function() {
    var allPrefetchedLiveBoardAssets = usePrefetchedLiveBoardAssets();
    var dnsPrefetchedDomains = allPrefetchedLiveBoardAssets.filter(function(asset) {
        return asset.type === prefetch_constants/* PREFETCH_TYPES.DNS_PREFETCH */.DO.DNS_PREFETCH;
    });
    var preConnectedDomains = allPrefetchedLiveBoardAssets.filter(function(asset) {
        return asset.type === prefetch_constants/* PREFETCH_TYPES.PRECONNECT */.DO.PRECONNECT;
    });
    return [
        dnsPrefetchedDomains === null || dnsPrefetchedDomains === void 0 ? void 0 : dnsPrefetchedDomains.map(function(prefetchedDomain, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: prefetchedDomain.type,
                href: prefetchedDomain.href
            }, index);
        }),
        preConnectedDomains === null || preConnectedDomains === void 0 ? void 0 : preConnectedDomains.map(function(preConnectedDomain, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: preConnectedDomain.type,
                href: preConnectedDomain.href
            }, index);
        })
    ];
};
/* harmony default export */ var liveboard_prefetched_assets_links_component = (LiveBoardPrefetchedAssetsLinksComponent);

// EXTERNAL MODULE: ./components/core/head/preconnect-links-component.js
var preconnect_links_component = __webpack_require__(62210);
;// CONCATENATED MODULE: ./components/core/head/glove/glove-script.js
// this script was provided by GloveFit

var SCRIPT_CONTENT = "\n    var aid = \"3872da8e-3211-11ef-b136-0affd97e338d\";\n    var url = encodeURIComponent(window.location.href);\n    fetch(\"https://console.glove.fit/api/general/tagurl?aid=\" + aid + \"&url=\" + url)\n    .then(response => response.json())\n    .then(data => {\n        if(data.status === 'ok') {\n            const script = document.createElement('script');\n            script.async = true;  // This sets the async attribute\n            script.src = data.url;\n            document.head.appendChild(script);\n        }\n    })\n    .catch(error => console.error('Error fetching the script URL:', error));\n  ";
var GloveScript = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
        dangerouslySetInnerHTML: {
            __html: SCRIPT_CONTENT
        }
    });
};
/* harmony default export */ var glove_script = (GloveScript);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./components/core/head/glove/glove-data-event-handler.js


var Sentry = __webpack_require__(48491);

var GloveDataEvents = {
    POPUP_OPENED: "FeedbackPopupOpened",
    USER_START_TYPING: "FeedbackPopupUserStartTyping",
    FEEDBACK_SUBMITTED: "FeedbackPopupSubmitted",
    POPUP_CLOSED: "FeedbackPopupClosed"
};
var _obj;
var eventHandlers = (_obj = {}, (0,_define_property/* default */.Z)(_obj, GloveDataEvents.POPUP_OPENED, function(data) {
    return (0,bigbrain_service.trackEvent)(bigbrain_event_types.GLOVE_FEEDBACK_POPUP_OPENED, data);
}), (0,_define_property/* default */.Z)(_obj, GloveDataEvents.USER_START_TYPING, function(data) {
    return (0,bigbrain_service.trackEvent)(bigbrain_event_types.GLOVE_FEEDBACK_POPUP_USER_START_TYPING, data);
}), (0,_define_property/* default */.Z)(_obj, GloveDataEvents.FEEDBACK_SUBMITTED, function(data) {
    return (0,bigbrain_service.trackEvent)(bigbrain_event_types.GLOVE_FEEDBACK_POPUP_SUBMITTED, data);
}), (0,_define_property/* default */.Z)(_obj, GloveDataEvents.POPUP_CLOSED, function(data) {
    return (0,bigbrain_service.trackEvent)(bigbrain_event_types.GLOVE_FEEDBACK_POPUP_CLOSED, data);
}), _obj);
// Variable to track if the event listener has already been added
var isMessageListenerAdded = false;
// Initialization function to set up the event listener
var initGloveEventHandler = function() {
    var handleGloveDataEvent = function handleGloveDataEvent(details) {
        var data = {
            "data": details.data
        };
        dispatchEvent(details.eventType, data);
    };
    var dispatchEvent = function dispatchEvent(eventType) {
        var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (eventHandlers[eventType]) {
            eventHandlers[eventType](data);
        } else {
            Sentry.captureMessage("Unknown event type: " + eventType);
        }
    };
    // Ensure the code only runs in the browser
    if (false) {}
    if (isMessageListenerAdded) return;
    // Add the message event listener
    window.addEventListener("message", function(event) {
        if (event.origin !== window.location.origin) {
            Sentry.captureMessage("Untrusted message origin: " + event.origin);
            return;
        }
        if (event.data.type === "GloveDataEvent") {
            handleGloveDataEvent(event.data.details);
        }
    });
    isMessageListenerAdded = true;
};
/* harmony default export */ var glove_data_event_handler = (initGloveEventHandler);

;// CONCATENATED MODULE: ./components/core/head/glove/glove-scripts.js


function GloveScripts() {
    glove_data_event_handler();
    return glove_script();
}

;// CONCATENATED MODULE: ./components/core/head/index.js

function head_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            head_define_property(target, key, source[key]);
        });
    }
    return target;
}
























var DEFAULT_TITLE_KEY = "website.meta.title.default";
var DEFAULT_DESCRIPTION_KEY = "website.meta.description.default";
var head_isProduction = "production" === "production";
var HPHead = function(props) {
    var clusterId = props.clusterId, hasFreeTier = props.hasFreeTier, cloudfrontViewerCountry = props.cloudfrontViewerCountry, disableGTM = props.disableGTM, description = props.description, template = props.template, localeId = props.localeId, noIndex = props.noIndex, noFollow = props.noFollow, gtmContainerId = props.gtmContainerId, isMobileOrTabletBrowser = props.isMobileOrTabletBrowser, pagePath = props.pagePath, facebookMetaOverride = props.facebookMetaOverride, twitterMetaOverride = props.twitterMetaOverride, translate = props.translate, localizedPages = props.localizedPages, abTests = props.abTests, translateWithParam = props.translateWithParam, title = props.title, canonicalUrl = props.canonicalUrl, shouldGetSignupPrefetchedAssets = props.shouldGetSignupPrefetchedAssets, seoFAQ = props.seoFAQ, shouldGetTypeformPrefetchedAssets = props.shouldGetTypeformPrefetchedAssets, useGloveReturnFromSignupFeedback = props.useGloveReturnFromSignupFeedback, useAdaBot = props.useAdaBot, persistantCookies = props.persistantCookies, preloadFirstFoldImages = props.preloadFirstFoldImages, addLiveBoardExperience = props.addLiveBoardExperience;
    var shouldAddGTM = head_isProduction && !disableGTM;
    (0,react.useEffect)(function() {
        if (shouldAddGTM) {
            (0,gtm_service/* addGTMVariablesToWindow */.jJ)({
                localeId: localeId,
                clusterId: clusterId,
                hasFreeTier: hasFreeTier
            });
            (0,gtm_service/* updateDataLayerVariables */.LC)({
                country: cloudfrontViewerCountry
            });
        }
    }, []);
    var getCanonicalUrl = function() {
        return (0,url.normalizeUrlForCanonical)(canonicalUrl || pagePath);
    };
    var getTitle = function() {
        if (typeof title === "object" && title.key && title.param) {
            return translateWithParam(title.key, title.param);
        }
        return translate(title);
    };
    var isHomepageOrPricingPage = function() {
        try {
            if (!pagePath) return false;
            var relevantNormalizedRoutes = [
                links/* ROOT_LINK */.yjY
            ].concat((0,_to_consumable_array/* default */.Z)((0,localization.getHomepageLocalizedRoutes)()), (0,_to_consumable_array/* default */.Z)(localization.LOCALIZED_PRICING_ROUTES));
            var normalizedPath = (0,url.normalizeUrl)((0,url.truncateQueryParams)(pagePath));
            return relevantNormalizedRoutes.includes(normalizedPath);
        } catch (e) {
            // TODO: talk with Barak - sentry is a pretty big import
            return false;
        }
    };
    var translatedTitle = getTitle();
    var translatedDescription = translate(description);
    // The <Head> component can only receive functions, not other components
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
            children: [
                !isMobileOrTabletBrowser && isHomepageOrPricingPage() && redirect_to_platform_script({
                    abTests: abTests,
                    persistantCookies: persistantCookies
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: translatedTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: translatedDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: getCanonicalUrl()
                }),
                (0,fonts_component/* default */.Z)(),
                getMetaTags({
                    template: template,
                    localeId: localeId,
                    noIndex: noIndex,
                    noFollow: noFollow
                }),
                (0,app_icons/* getAppIconsLinks */.J)(),
                getFacebookMetaTags(_object_spread({
                    title: translatedTitle,
                    description: translatedDescription,
                    pagePath: pagePath
                }, facebookMetaOverride)),
                (0,faq_seo/* default */.Z)({
                    seoFAQ: seoFAQ,
                    translate: translate
                }),
                getTwitterMetaTags(_object_spread({
                    title: translatedTitle,
                    description: translatedDescription
                }, twitterMetaOverride)),
                (0,google_structured_data/* default */.Z)(),
                shouldAddGTM && (0,google_tag_manager_component/* default */.Z)({
                    gtmId: gtmContainerId
                }),
                localizedPages && localizedPages.map(function(tp, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        hrefLang: tp.locale,
                        href: tp.path
                    }, index);
                }),
                shouldGetSignupPrefetchedAssets && (0,signup_prefetched_assets_links_component/* default */.Z)(),
                addLiveBoardExperience && liveboard_prefetched_assets_links_component(),
                (preloadFirstFoldImages === null || preloadFirstFoldImages === void 0 ? void 0 : preloadFirstFoldImages.length) && first_fold_images(preloadFirstFoldImages),
                (0,preconnect_links_component/* default */.Z)(),
                useGloveReturnFromSignupFeedback && GloveScripts()
            ]
        })
    });
};
HPHead.defaultProps = {
    title: DEFAULT_TITLE_KEY,
    description: DEFAULT_DESCRIPTION_KEY,
    canonicalUrl: "",
    withIntercom: false,
    fontLazyLoad: false,
    disableGTM: false,
    facebookMetaOverride: {},
    twitterMetaOverride: {},
    localizedPages: []
};
/* harmony default export */ var core_head = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(HPHead)));

// EXTERNAL MODULE: ./components/core/head/header-scripts-component.js + 16 modules
var header_scripts_component = __webpack_require__(25433);
// EXTERNAL MODULE: ./services/ab-tests/lp-ab-tests-service.js
var lp_ab_tests_service = __webpack_require__(36233);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./components/core/head/fullstory-scripts/fullstory-script.js




function fullstory_script_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fullstory_script_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fullstory_script_define_property(target, key, source[key]);
        });
    }
    return target;
}








var FULLSTORY_RECORDING_FOR_VISITOR = "fullstory_recording_for_visitor";
var ALWAYS_RECORD_COOKIE_EXPIRY_DAYS = 3;
var DEFAULT_RAND_RECORD = 100;
var FullstoryScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(FullstoryScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(FullstoryScript);
    function FullstoryScript() {
        (0,_class_call_check/* default */.Z)(this, FullstoryScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(FullstoryScript, [
        {
            key: "getFullstoryBaseCode",
            value: function getFullstoryBaseCode() {
                return "\n        window['_fs_host'] = 'fullstory.com';\n        window['_fs_script'] = 'edge.fullstory.com/s/fs.js';\n        window['_fs_org'] = 'WSWD';\n        window['_fs_namespace'] = 'FS';\n        (function(m,n,e,t,l,o,g,y){\n            if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n            g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n            o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n            y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);\n            g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n            g.anonymize=function(){g.identify(!!0)};\n            g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n            g.log = function(a,b){g(\"log\",[a,b])};\n            g.consent=function(a){g(\"consent\",!arguments.length||a)};\n            g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n            g.clearUserCookie=function(){};\n            g.setVars=function(n, p){g('setVars',[n,p]);};\n            g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n            if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n            g._v=\"1.3.0\";\n        })(window,document,window['_fs_namespace'],'script','user');";
            }
        },
        {
            // Do not add dynamic attributes - runtime variables (cookies, dynamic ab test, etc...)
            // Only use params that we are cache upon
            key: "prepareAbTestParams",
            value: function prepareAbTestParams() {
                var abTests = this.props.abTests;
                var abTestsParams = {};
                abTests.forEach(function(abTest) {
                    return abTestsParams["homepage_ab_test_".concat(abTest.name, "_str")] = abTest.variant;
                });
                return abTestsParams;
            }
        },
        {
            // If you need to send dynamic attributes use FS.event when needed
            key: "createAdditionalAttributes",
            value: function createAdditionalAttributes() {
                var _props = this.props, abTestExactEventName = _props.abTestExactEventName, clusterId = _props.clusterId, subClusterId = _props.subClusterId, hasFreeTier = _props.hasFreeTier, localeId = _props.localeId, abTests = _props.abTests;
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTests);
                var abTestsParams = this.prepareAbTestParams();
                return fullstory_script_object_spread({
                    lp_ab_test_str: abTestVariant,
                    clusterId_str: clusterId,
                    subClusterId_str: subClusterId,
                    hasFreeTier_bool: hasFreeTier,
                    localeId_str: localeId || localization.ENGLISH_LOCALE_ID
                }, abTestsParams);
            }
        },
        {
            key: "onError",
            value: function onError(error) {
                esm_exports/* captureException */.Tb(error);
                esm_exports/* captureMessage */.uT("Error occur on FS script");
            }
        },
        {
            key: "fullstoryScriptGenerator",
            value: function fullstoryScriptGenerator() {
                var _props = this.props, fullstoryRecordingFrequency = _props.fullstoryRecordingFrequency, clusterId = _props.clusterId;
                var attributes = this.createAdditionalAttributes();
                var recordEveryNth = fullstoryRecordingFrequency ? parseInt(fullstoryRecordingFrequency) : DEFAULT_RAND_RECORD;
                return "\n    	try {\n				if (!window.fs_appended) {\n					window.fs_appended = true;\n\n					".concat(cookieValueByNameInlineScript, "\n					").concat(setCookieInlineScript, "\n					").concat(shouldRecordFromDrawInlineScript, "\n\n					const shouldAlwaysRecord = cookieValueByName('").concat(cookies.ALWAYS_FS, "');\n\n					if (shouldAlwaysRecord || shouldRecordFromDraw(").concat(recordEveryNth, ")) {\n					// localstorage for testing on production\n\n						if (!shouldAlwaysRecord) {\n							//	no need to set twice\n							setCookie('").concat(cookies.ALWAYS_FS, "', true, ").concat(ALWAYS_RECORD_COOKIE_EXPIRY_DAYS, ");\n						}\n\n						").concat(this.getFullstoryBaseCode(), "\n\n						visitorId = cookieValueByName('").concat(cookies.BIG_BRAIN_VISITOR_ID, '\');\n						FS.setUserVars({"visitorId": visitorId});\n						FS.setUserVars(').concat(JSON.stringify(attributes), ');\n            window.FSSessionStartedAt = Date.now();\n						window.BigBrain("track","').concat(FULLSTORY_RECORDING_FOR_VISITOR, '", { kind: "').concat(clusterId || "", '", info1: "').concat(recordEveryNth, "\", data: '").concat(JSON.stringify(attributes), "' });\n					}\n        }\n			}\n			catch(e) {\n			}\n    ");
            }
        },
        {
            key: "render",
            value: function render() {
                var script = this.fullstoryScriptGenerator();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    async: true,
                    defer: true,
                    dangerouslySetInnerHTML: {
                        __html: script
                    }
                });
            }
        }
    ]);
    return FullstoryScript;
}(react.PureComponent);
/* harmony default export */ var fullstory_script = ((0,ab_tests_context/* withAbTests */.k)(FullstoryScript));

;// CONCATENATED MODULE: ./components/core/head/seo-scripts/trustpilot-script.js






var TrustpilotScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TrustpilotScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TrustpilotScript);
    function TrustpilotScript() {
        (0,_class_call_check/* default */.Z)(this, TrustpilotScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TrustpilotScript, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "text/javascript",
                    src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                    async: true,
                    defer: true
                });
            }
        }
    ]);
    return TrustpilotScript;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/core/head/intercom-scripts/intercom-script.js






var INTERCOM_APP_ID = "pqqwlkj5";
var IntercomScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(IntercomScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(IntercomScript);
    function IntercomScript() {
        (0,_class_call_check/* default */.Z)(this, IntercomScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(IntercomScript, [
        {
            key: "intercomSettingsScriptGenerator",
            value: function intercomSettingsScriptGenerator(userData, isProduction) {
                var appId = INTERCOM_APP_ID;
                var userId = userData.userId, name = userData.name, email = userData.email, additionalData = userData.additionalData;
                var additionalDataStr = additionalData ? JSON.stringify(additionalData) : "{}";
                if (userId) {
                    // Logged in users
                    return "\n        window['intercomSettings'] = Object.assign({}, {\n          app_id: \"".concat(appId, '",\n          user_id: "').concat(userId, '",\n          name: "').concat(name, '", // Full name\n          email: "').concat(email, '" // Email address          \n        }, ').concat(additionalDataStr, ");\n        \n      ");
                } else {
                    return "\n        window['intercomSettings'] = {\n          app_id: \"".concat(appId, '"\n        };\n      ');
                }
            }
        },
        {
            key: "intercomScriptGenerator",
            value: function intercomScriptGenerator() {
                return "\n      (function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments)};i.q=[];i.c=function(args){i.q.push(args)};w.Intercom=i;function l(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/pqqwlkj5';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);}if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()\n    ";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, userData = _props.userData, isProduction = _props.isProduction;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            async: true,
                            defer: true,
                            dangerouslySetInnerHTML: {
                                __html: this.intercomSettingsScriptGenerator(userData, isProduction)
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            async: true,
                            defer: true,
                            dangerouslySetInnerHTML: {
                                __html: this.intercomScriptGenerator()
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return IntercomScript;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/new-ab-tests/new-ab-tests-service.js
var new_ab_tests_service = __webpack_require__(41871);
;// CONCATENATED MODULE: ./services/body-scripts-service.js

var initBodyScripts = function initBodyScripts(param) {
    var abTests = param.abTests;
    (0,new_ab_tests_service.fireEventsOnServerRedirectTests)(abTests);
};

// EXTERNAL MODULE: ./client/services/hotjar-service/hotjar-service.js
var hotjar_service = __webpack_require__(96339);
;// CONCATENATED MODULE: ./components/core/head/hotjar-script.js








var HotjarScript = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HotjarScript, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HotjarScript);
    function HotjarScript() {
        (0,_class_call_check/* default */.Z)(this, HotjarScript);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(HotjarScript, [
        {
            key: "startHotjarSessionByVariant",
            value: function startHotjarSessionByVariant(abTestVariant) {
                return (0,hotjar_service/* fireHotjarEventScript */.jB)(abTestVariant);
            }
        },
        {
            key: "renderHotjarScript",
            value: function renderHotjarScript() {
                return "\n        (function(h,o,t,j,a,r){\n          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n          h._hjSettings={hjid:1566695,hjsv:6};\n          a=o.getElementsByTagName('head')[0];\n          r=o.createElement('script');r.async=1;\n          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n          a.appendChild(r);\n    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');\n  ";
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, abTests = _props.abTests, abTestExactEventName = _props.abTestExactEventName;
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTests);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            dangerouslySetInnerHTML: {
                                __html: this.renderHotjarScript()
                            }
                        }),
                        abTestVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                            async: true,
                            dangerouslySetInnerHTML: {
                                __html: this.startHotjarSessionByVariant(abTestVariant)
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return HotjarScript;
}(react.PureComponent);


// EXTERNAL MODULE: ./services/countries/countries-service.js
var countries_service = __webpack_require__(85010);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mondaydotcomorg/chat-client/dist/index.js
var dist = __webpack_require__(18243);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./components/core/body-scripts/body-scripts-component.js


















var body_scripts_component_isProduction = "production" === "production";
var HotjarWithAbTests = (0,ab_tests_context/* withAbTests */.k)(HotjarScript);
var CHATBOT_SCRIPT_URL = "https://microfrontends.monday.com/scripts/growth-cx-mf-renderer.js";
var BodyScriptsComponent = function(props) {
    var abTests = props.abTests, withFullstory = props.withFullstory, fullstoryRecordingFrequency = props.fullstoryRecordingFrequency, showTrustpilotReviews = props.showTrustpilotReviews, withIntercom = props.withIntercom, disableGTM = props.disableGTM, gtmContainerId = props.gtmContainerId, enableHotjar = props.enableHotjar, hotjarFinalDate = props.hotjarFinalDate, clusterId = props.clusterId, hasFreeTier = props.hasFreeTier, localeId = props.localeId, subClusterId = props.subClusterId, loggedInUser = props.loggedInUser, cloudfrontViewerCountry = props.cloudfrontViewerCountry, is404Page = props.is404Page, customBodyScript = props.customBodyScript, useAdaBot = props.useAdaBot;
    (0,react.useEffect)(function() {
        initBodyScripts({
            abTests: abTests
        });
    }, [
        abTests
    ]);
    var isCountrySupportedForChatbot = (0,react.useCallback)(function() {
        if (cloudfrontViewerCountry === countries_service.ISRAEL_ISO2 || cloudfrontViewerCountry === countries_service.UNITED_STATES_ISO2 || cloudfrontViewerCountry === countries_service.CANADA_ISO2) return true;
        return (0,countries_service.getCountriesByContinent)(countries_service.EUROPE).includes(cloudfrontViewerCountry);
    }, [
        cloudfrontViewerCountry
    ]);
    (0,react.useEffect)(function() {
        if (is404Page) {
            var _window_location, _window, _document;
            var href = (_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : _window_location.href;
            var referrer = (_document = document) === null || _document === void 0 ? void 0 : _document.referrer;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.RETRIEVED_404_ERROR, {
                kind: href,
                info1: referrer
            });
        }
    }, [
        is404Page
    ]);
    (0,react.useEffect)(function() {
        if (useAdaBot) {
            var scriptElement = document.createElement("script");
            scriptElement.src = CHATBOT_SCRIPT_URL;
            scriptElement.defer = true;
            document.body.appendChild(scriptElement);
            scriptElement.onload = function() {
                setTimeout(function() {
                    var metaData = (0,cookies_service/* getCookie */.ej)(cookies.CONTACT_SALES_FORM_DATA);
                    (0,dist.triggerChat)((dist.ChatSourceName === null || dist.ChatSourceName === void 0 ? void 0 : dist.ChatSourceName.CONTACT_SALES_HOMEPAGE) || "contact-sales-homepage", metaData);
                }, 3000);
            };
        }
    }, [
        useAdaBot
    ]);
    var loggedInUserToUse = loggedInUser || {};
    var shouldAddHotjarScript = function() {
        return enableHotjar && (0,hotjar_service/* currentSmallerThanFinalDate */.FZ)(hotjarFinalDate);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: body_scripts_component_isProduction && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !disableGTM && // This MUST be rendered in the body so componentDidMount will run
                /*#__PURE__*/ (0,jsx_runtime.jsx)(google_tag_manager_component/* default */.Z, {
                    loadBodyScript: true,
                    gtmId: gtmContainerId
                }),
                withFullstory && /*#__PURE__*/ (0,jsx_runtime.jsx)(fullstory_script, {
                    clusterId: clusterId,
                    subClusterId: subClusterId,
                    fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                    hasFreeTier: hasFreeTier,
                    localeId: localeId
                }),
                showTrustpilotReviews && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustpilotScript, {}),
                withIntercom && /*#__PURE__*/ (0,jsx_runtime.jsx)(IntercomScript, {
                    userData: {
                        userId: loggedInUserToUse.mondayUserId || loggedInUserToUse.id,
                        name: loggedInUserToUse.name,
                        email: loggedInUserToUse.email,
                        additionalData: loggedInUserToUse.intercomData
                    },
                    isProduction: body_scripts_component_isProduction
                }),
                shouldAddHotjarScript() && /*#__PURE__*/ (0,jsx_runtime.jsx)(HotjarWithAbTests, {}),
                useAdaBot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "mf-growth-cx-root"
                }),
                customBodyScript && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    dangerouslySetInnerHTML: {
                        __html: customBodyScript
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var body_scripts_component = ((0,generic_config_context/* withGenericConfig */.P)((0,ab_tests_context/* withAbTests */.k)((0,router.withRouter)(BodyScriptsComponent))));
BodyScriptsComponent.defaultProps = {
    withFullstory: false,
    showTrustpilotReviews: false,
    withIntercom: false,
    fontLazyLoad: false,
    disableGTM: false
};

// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(93096);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
;// CONCATENATED MODULE: ./services/cookies/cloudfront-viewer-country-cookies-service.js


var saveCloudfrontViewerCountryCookie = function(cloudfrontViewerCountry) {
    cloudfrontViewerCountry && (0,cookies_service/* setCookie */.d8)(cookies.CLOUDFRONT_VIEWER_COUNTRY_COOKIE_NAME, cloudfrontViewerCountry);
};

// EXTERNAL MODULE: ./services/dom-utils-service.js
var dom_utils_service = __webpack_require__(44566);
// EXTERNAL MODULE: ./services/utils-service.js
var utils_service = __webpack_require__(20618);
// EXTERNAL MODULE: ./components/accessibility/bypass-blocks-menu/bypass-block-menu.js + 1 modules
var bypass_block_menu = __webpack_require__(17730);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
// EXTERNAL MODULE: ./constants/pricing-versions.js
var pricing_versions = __webpack_require__(78803);
var pricing_versions_default = /*#__PURE__*/__webpack_require__.n(pricing_versions);
// EXTERNAL MODULE: ./utils/react.js
var utils_react = __webpack_require__(12783);
// EXTERNAL MODULE: ./client/services/signup/prefetch-signup-service.js
var prefetch_signup_service = __webpack_require__(95315);
// EXTERNAL MODULE: ./components/templates/base-template.scss.js
var base_template_scss = __webpack_require__(89548);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-modal.scss.js


var StylesLiveBoardPopupModal = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1b8yo6x0"
})(".live-board-modal{position:fixed;height:100vh;width:100vw;background-color:rgba(0,0,0,0.7);}.live-board-modal-overlay{position:fixed;top:100vh;opacity:0;z-index:", z_index/* ZERO */.xE, ";transition:opacity 1s;&.fullscreen-board{top:0;opacity:1;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";}}.modal-open{overflow-y:scroll;&.fullscreen-board{overflow-y:hidden;}}");

// EXTERNAL MODULE: ./static/svg/close.svg
var svg_close = __webpack_require__(1725);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.js + 1 modules
var embedded_board = __webpack_require__(94598);
;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/views-tab-content/views-tab-component.scss.js

var StyledViewsTabContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ivsiw00"
})(".live-board-tab-wrapper{.responsive-hoc-component{.desktop-wrapper{.flexible-cards-grid-desktop-component{.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{.top-layer{.grid-paragraph-with-image{.grid-paragraph-wrapper{padding-bottom:0px;.full-paragraph{.title-wrapper{margin-bottom:0px;.core-title-container .core-title{font-size:1.2rem;}}}}}}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph.js + 2 modules
var grid_image_with_paragraph = __webpack_require__(47755);
;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/live-board-tabs-service.js
function live_board_tabs_service_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_tabs_service_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_tabs_service_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var getGridImageWithParagraphProps = function(param) {
    var _imageSrc = param.imageSrc, imageSrc = _imageSrc === void 0 ? null : _imageSrc, _fullParagraphTitle = param.fullParagraphTitle, fullParagraphTitle = _fullParagraphTitle === void 0 ? null : _fullParagraphTitle, _fullParagraphBody = param.fullParagraphBody, fullParagraphBody = _fullParagraphBody === void 0 ? null : _fullParagraphBody, _fullParagraphTopic = param.fullParagraphTopic, fullParagraphTopic = _fullParagraphTopic === void 0 ? null : _fullParagraphTopic;
    var fullParagraph = _object_spread_props(live_board_tabs_service_object_spread({}, grid_image_with_paragraph/* default.defaultProps.fullParagraph */.Z.defaultProps.fullParagraph), {
        topic: {
            text: fullParagraphTopic
        },
        title: fullParagraphTitle,
        body: fullParagraphBody
    });
    return _object_spread_props(live_board_tabs_service_object_spread({}, grid_image_with_paragraph/* default.defaultProps */.Z.defaultProps), {
        src: imageSrc,
        fullParagraph: fullParagraph
    });
};

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/views-tab-content/views-tab-consts.js

var firstRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/dashboard_views.png",
        fullParagraphTitle: "Dashboard"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/gantt_views.png",
        fullParagraphTitle: "Gantt"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/kanbann_views.png",
        fullParagraphTitle: "Kanban"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/gallary_views.png",
        fullParagraphTitle: "Files Gallery"
    })
];
var secondRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/calendar_views.png",
        fullParagraphTitle: "Calendar"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/workload_views.png",
        fullParagraphTitle: "Workload"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/Timeline_views.png",
        fullParagraphTitle: "Timeline"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/map_views.png",
        fullParagraphTitle: "Map"
    })
];
var thirdRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/form_views.png",
        fullParagraphTitle: "Form"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/cards_views.png",
        fullParagraphTitle: "Cards"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/chart_views.png",
        fullParagraphTitle: "Chart"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/views/Files_views.png",
        fullParagraphTitle: "Files"
    })
];
var viewsGridItems = [
    firstRow,
    secondRow,
    thirdRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/live-board-tab-component.scss.js

var StyledLiveBoardTabComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "efjqr30"
})("display:flex;justify-content:center;width:82vw;.tab-content{padding-bottom:200px;width:95%;cursor:default;.description-wrapper{text-align:center;padding-bottom:16px;}.responsive-hoc-component{.desktop-wrapper{.flexible-cards-grid-desktop-component{.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{.top-layer{.grid-paragraph-with-image{cursor:pointer;&:not(:hover){box-shadow:unset;border:1px solid #dcdfec;border-radius:8px;}&:hover{border:unset;border-radius:8px;border:1px solid #dcdfec;}.grid-image-wrapper{.grid-image{.picture-component{img{border-bottom-right-radius:unset;border-bottom-left-radius:unset;}}}}}}}}}}}}&.hide-paragraph{.responsive-hoc-component{.desktop-wrapper{.flexible-cards-grid-desktop-component{.flexible-cards-grid-desktop-component-inner{.grid-paragraph-with-image-component-wrapper{.top-layer{.grid-paragraph-with-image{.grid-paragraph-wrapper{display:none;}}}}}}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/paragraph.js + 1 modules
var paragraph = __webpack_require__(75073);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component.js + 5 modules
var flexible_cards_grid_component = __webpack_require__(38885);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/live-board-tab-component.js
function live_board_tab_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_tab_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_tab_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function live_board_tab_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function live_board_tab_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        live_board_tab_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var LiveBoardTabComponent = function(props) {
    var description = props.description, topAssetProps = props.topAssetProps, gridItems = props.gridItems, hideCardParagraph = props.hideCardParagraph, onCardClick = props.onCardClick, hideVideoControls = props.hideVideoControls, onAssetClick = props.onAssetClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLiveBoardTabComponent, {
        className: classnames_default()("live-board-tab-wrapper", {
            "hide-paragraph": hideCardParagraph
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tab-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "description-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {
                        body: description
                    })
                }),
                topAssetProps && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "asset-wrapper",
                    onClick: onAssetClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, live_board_tab_component_object_spread_props(live_board_tab_component_object_spread({}, topAssetProps), {
                        hideControls: hideVideoControls
                    }))
                }),
                gridItems === null || gridItems === void 0 ? void 0 : gridItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-cards-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(flexible_cards_grid_component["default"], {
                            gridItems: item,
                            gridAlignment: align_types.ALIGN_TYPES.CENTER,
                            defaultCardClick: onCardClick
                        })
                    });
                })
            ]
        })
    });
};
/* harmony default export */ var live_board_tab_component = (LiveBoardTabComponent);

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/views-tab-content/views-tab-component.js





var ViewsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledViewsTabContentComponent, {
        className: "views-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.viewsTab.description"),
            gridItems: viewsGridItems,
            onCardClick: onCardClick
        })
    });
};
/* harmony default export */ var views_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(ViewsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/integrations-tab-content/integrations-tab-consts.js

var integrations_tab_consts_firstRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/gmail.png",
        fullParagraphTitle: "integrations - gmail"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/slack.png",
        fullParagraphTitle: "integrations - slack"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/zoom.png",
        fullParagraphTitle: "integrations - zoom"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/zendesk.png",
        fullParagraphTitle: "integrations - zendesk"
    })
];
var integrations_tab_consts_secondRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/hubspot.png",
        fullParagraphTitle: "integrations - hubspot"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/jira.png",
        fullParagraphTitle: "integrations - jira"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/google_drive.png",
        fullParagraphTitle: "integrations - google drive"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/microsoft_teams.png",
        fullParagraphTitle: "integrations - microsoft teams"
    })
];
var integrations_tab_consts_thirdRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/github.png",
        fullParagraphTitle: "integrations - github"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/outlook.png",
        fullParagraphTitle: "integrations - outlook"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/paypal.png",
        fullParagraphTitle: "integrations - paypal"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/dropbox.png",
        fullParagraphTitle: "integrations - dropbox"
    })
];
var fourthRow = [
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/twiio.png",
        fullParagraphTitle: "integrations - twilio"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/mailchimp.png",
        fullParagraphTitle: "integrations - mailchimp"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/integrations/survey_monkey.png",
        fullParagraphTitle: "integrations - survey monkey"
    }),
    getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/200.png",
        fullParagraphTitle: "integrations - 200+"
    })
];
var integrationsGridItems = [
    integrations_tab_consts_firstRow,
    integrations_tab_consts_secondRow,
    integrations_tab_consts_thirdRow,
    fourthRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/integrations-tab-content/integrations-tab-component.js




var IntegrationsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "integrations-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.integrationsTab.description"),
            gridItems: integrationsGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick
        })
    });
};
/* harmony default export */ var integrations_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(IntegrationsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/automations-tab-content/automations-tab-consts.js
function automations_tab_consts_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function automations_tab_consts_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            automations_tab_consts_define_property(target, key, source[key]);
        });
    }
    return target;
}
function automations_tab_consts_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function automations_tab_consts_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        automations_tab_consts_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var TOP_VIDEO_PROPS = {
    video: {
        src: {
            singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/live-board-2022/automations/automation.mp4"
        },
        autoPlay: true,
        playWhenVisible: false,
        loop: true
    }
};
var automations_tab_consts_firstRow = [
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/1_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 1"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/2_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 2"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/3_card_automation.png",
        fullParagraphTitle: "automations - row: 1 col: 3"
    })), {
        cardNumOfColumnsWidth: 1.33
    })
];
var automations_tab_consts_secondRow = [
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/4_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 1"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/5_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 2"
    })), {
        cardNumOfColumnsWidth: 1.33
    }),
    automations_tab_consts_object_spread_props(automations_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/automations/6_card_automation.png",
        fullParagraphTitle: "automations - row: 2 col: 3"
    })), {
        cardNumOfColumnsWidth: 1.33
    })
];
var automationsGridItems = [
    automations_tab_consts_firstRow,
    automations_tab_consts_secondRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/automations-tab-content/automations-tab-component.js




var AutomationsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "automations-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.automationsTab.description"),
            gridItems: automationsGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick,
            topAssetProps: TOP_VIDEO_PROPS,
            hideVideoControls: true,
            onAssetClick: onCardClick
        })
    });
};
/* harmony default export */ var automations_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(AutomationsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/invite-tab-content/invite-tab-consts.js
function invite_tab_consts_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function invite_tab_consts_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            invite_tab_consts_define_property(target, key, source[key]);
        });
    }
    return target;
}
function invite_tab_consts_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function invite_tab_consts_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        invite_tab_consts_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var invite_tab_consts_firstRow = [
    invite_tab_consts_object_spread_props(invite_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/invite/invite_image.png",
        fullParagraphTitle: "invite - row: 1"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var invite_tab_consts_secondRow = [
    invite_tab_consts_object_spread_props(invite_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/invite/1_invite_card.png",
        fullParagraphTitle: "invite - row: 2 col: 1"
    })), {
        cardNumOfColumnsWidth: 2
    }),
    invite_tab_consts_object_spread_props(invite_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/invite/2_invite_card.png",
        fullParagraphTitle: "invite - row: 2 col: 2"
    })), {
        cardNumOfColumnsWidth: 2
    })
];
var inviteGridItems = [
    invite_tab_consts_firstRow,
    invite_tab_consts_secondRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/invite-tab-content/invite-tab-component.js




var InviteTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "invite-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.inviteTab.description"),
            gridItems: inviteGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick
        })
    });
};
/* harmony default export */ var invite_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(InviteTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/notifications-tab-content/notifications-tab-consts.js
function notifications_tab_consts_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function notifications_tab_consts_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            notifications_tab_consts_define_property(target, key, source[key]);
        });
    }
    return target;
}
function notifications_tab_consts_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function notifications_tab_consts_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        notifications_tab_consts_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

var notifications_tab_consts_firstRow = [
    notifications_tab_consts_object_spread_props(notifications_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/notifications/Notification_1.png",
        fullParagraphTitle: "notifications - row: 1"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var notifications_tab_consts_secondRow = [
    notifications_tab_consts_object_spread_props(notifications_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/notifications/Notification_2.png",
        fullParagraphTitle: "notifications - row: 2"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var notifications_tab_consts_thirdRow = [
    notifications_tab_consts_object_spread_props(notifications_tab_consts_object_spread({}, getGridImageWithParagraphProps({
        imageSrc: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/notifications/Notification_3.png",
        fullParagraphTitle: "notifications - row: 3"
    })), {
        cardNumOfColumnsWidth: 4
    })
];
var notificationsGridItems = [
    notifications_tab_consts_firstRow,
    notifications_tab_consts_secondRow,
    notifications_tab_consts_thirdRow
];

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/notifications-tab-content/notifications-tab-component.js




var NotificationsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "notifications-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.notificationsTab.description"),
            gridItems: notificationsGridItems,
            onCardClick: onCardClick,
            hideCardParagraph: true
        })
    });
};
/* harmony default export */ var notifications_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(NotificationsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/dashboards-tab-content/dashboards-tab-consts.js
var dashboards_tab_consts_TOP_VIDEO_PROPS = {
    video: {
        src: {
            singleUrl: "https://dapulse-res.cloudinary.com/video/upload/Generator_featured%20images/live-board-2022/dashboards/Dashboars_Reports_2022.mp4"
        },
        autoPlay: true,
        playWhenVisible: false,
        loop: true
    }
};

;// CONCATENATED MODULE: ./components/core/live-board-experience/tabs-content/dashboards-tab-content/dashboards-tab-component.js




var DashboardsTabContentComponent = function(props) {
    var translate = props.translate, onCardClick = props.onCardClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dashboards-tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_tab_component, {
            description: translate("liveBoard.dashboardsTab.description"),
            topAssetProps: dashboards_tab_consts_TOP_VIDEO_PROPS,
            hideVideoControls: true,
            onAssetClick: onCardClick
        })
    });
};
/* harmony default export */ var dashboards_tab_component = ((0,generic_config_context/* withGenericConfig */.P)(DashboardsTabContentComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-consts.js







var MAIN_TABLE_TAB_ID = "MIAN_TABLE";
var tabs = [
    {
        tabLabel: "Main table",
        tabID: MAIN_TABLE_TAB_ID,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_home.svg"
        },
        liveBoardTabComponent: embedded_board/* default */.Z,
        scrollVisible: true,
        componentProps: {
            hideTopFrame: true,
            isLiveBoard: true
        }
    },
    {
        tabLabel: "Dashboards",
        tabID: "DASHBOARDS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/icon_dashboard.svg"
        },
        liveBoardTabComponent: dashboards_tab_component
    },
    {
        tabLabel: "Views",
        tabID: "VIEWS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_views.svg"
        },
        liveBoardTabComponent: views_tab_component
    },
    {
        tabLabel: "Integrations",
        tabID: "INTEGRATIONS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_integrations.svg"
        },
        liveBoardTabComponent: integrations_tab_component
    },
    {
        tabLabel: "Automations",
        tabID: "AUTOMATIONS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_automations.svg"
        },
        liveBoardTabComponent: automations_tab_component
    },
    {
        tabLabel: "Invite",
        tabID: "INVITE",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_invite.svg"
        },
        liveBoardTabComponent: invite_tab_component
    },
    {
        tabLabel: "Notifications",
        tabID: "NOTIFICATIONS",
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/2_icon_notifications.svg"
        },
        liveBoardTabComponent: notifications_tab_component
    }
];
var LIVE_BOARD_VW_WIDTH = 90;
var RIGHT_SECTION_VW_WIDTH = LIVE_BOARD_VW_WIDTH;
var RIGHT_SECTION_RIGHT_VW_MARGIN = 2;
var BANNER_RIGHT_VW_MARGIN = 3;
var BANNER_LEFT_VW_MARGIN = 1;
var BANNER_VW_WIDTH = LIVE_BOARD_VW_WIDTH - BANNER_LEFT_VW_MARGIN - BANNER_RIGHT_VW_MARGIN;
var LIVE_BOARD_BUTTON_CLOSE_ICON = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/live-board-2022/button/close_icon.svg";

// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-screen-component.scss.js






var StyledLiveBoardScreenComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e16y0ma30"
})("display:flex;width:100%;height:100%;.live-board-open-button-wrapper{display:flex;align-items:center;.live-board-open-button-content{z-index:", z_index/* LAYER_ONE */.KW, ";padding-left:4px;@media (max-width:", vp_sizes/* LARGE_SCREEN_MIN_WIDTH */.vA, "){top:70vh;}.x-button-wrapper{display:none;}&:hover{.x-button-wrapper{display:unset;position:absolute;cursor:pointer;top:0;left:0;}}}}.live-board-close{position:absolute;top:16px;left:16px;cursor:pointer;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";}.close-icon{width:28px;height:22px;path{stroke:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";}}.live-board-content-wrapper{display:flex;border-top-left-radius:12px;border-top-right-radius:12px;width:", LIVE_BOARD_VW_WIDTH + "vw", ";height:98%;margin-top:2%;margin-left:5%;margin-right:5%;justify-content:center;background:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";pointer-events:auto;.right-section{width:", RIGHT_SECTION_VW_WIDTH + "vw", ";margin-right:", RIGHT_SECTION_RIGHT_VW_MARGIN + "vw", ";padding-left:1vw;.board-title-wrapper{display:flex;flex-direction:row;justify-content:space-between;padding-top:44px;padding-left:30px;.title-content{display:flex;flex-direction:row;gap:28px;align-items:baseline;.tag{padding:0 10px;margin:0 2px;font-weight:400;font-size:1rem;line-height:154%;border-radius:2px;width:fit-content;color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";background-color:", colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01], ";}}}.board-views-tab-component{padding-top:20px;padding-left:20px;height:100%;.tabs-component-wrapper{height:100%;.tabs-component{height:100%;.tabs{border-bottom:1px solid #c3c6d4;margin-left:20px;justify-content:left;gap:32px;.tab-component{.title-wrapper{.title-and-icon-wrapper{.icon-wrapper{margin-right:8px;.picture-icon-wrapper{height:25px;}}}}&.active{.tab-underline-placeholder{background:#0073ea;height:2px;}}}}@media (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_MAX_WIDTH */.po, "){.tabs{gap:16px;.tab-component{.title-wrapper{.title-and-icon-wrapper{.monday-markup-language-component{font-size:1rem;@media (max-width:", vp_sizes/* MACBOOK_PRO_MAX_WIDTH */.Wh, "){font-size:0.9rem;}}}}}}}.content{height:75%;padding-top:32px;.asset-wrapper{opacity:unset;min-height:unset;margin:16px 30px;.asset-inner{cursor:pointer;.video-component{.react-player-video-component{video{border-radius:12px;}}}}}@media (min-width:", vp_sizes/* X_LARGE_SCREEN_MIN_WIDTH */.M$, "){.asset-wrapper{margin:16px 60px;}}.tab-component{height:100%;padding:unset;overflow:scroll;:hover{background-color:unset;}.embedded-board{.tooltip-wrapper{justify-content:left;bottom:unset;top:230px;margin-left:10px;.tooltip{&:after{bottom:40px;transform:rotate(180deg);}}}.embedded-wrapper{border:unset;}}&.scroll-visible{overflow:visible;}}}}}}.banner-wrapper{position:fixed;opacity:0;transition-property:opacity;transition-duration:0.15s;z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";bottom:2vh;margin-right:", BANNER_RIGHT_VW_MARGIN + "vw", ";margin-left:", BANNER_LEFT_VW_MARGIN + "vw", ";.shake{.banner{width:", BANNER_VW_WIDTH + "vw", ";border-radius:8px;.banner-content{.banner-text-and-cta{.banner-text-and-link{flex-direction:row;.banner-cta-wrapper{.button{.signup-button{.error-handling-component{.shake{.signup-form-core-component-wrapper{.signup-form{.signup-button-wrapper{.ladda-button{color:", colors/* default */.Z[color_consts.DARK_WORK_OS_IRIS_COLOR_NAME], ";}}}}}}}}}}}}}}}}}&.board-fully-visible{.live-board-content-wrapper{.right-section{.banner-wrapper{opacity:1;}}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.js + 1 modules
var board_views_tab = __webpack_require__(20959);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/title.js + 1 modules
var title = __webpack_require__(91265);
// EXTERNAL MODULE: ./segments/desktop/core-components/banner/banner.js + 2 modules
var banner = __webpack_require__(15814);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./components/enhancements/shake/shake-component.js + 1 modules
var shake_component = __webpack_require__(89868);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/signup-button.js + 1 modules
var signup_button = __webpack_require__(85850);
;// CONCATENATED MODULE: ./components/core/live-board-experience/default-props.js
/* harmony default export */ var default_props = ({
    bannerText: "Project Plan",
    embeddedBoardTitle: "Sign up for free to gain full access to all features",
    embeddedBoardLink: "https://view.monday.com/3565981122-91f9221ceff3c454e3b37cbc72ea5d33?r=use1"
});

;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-screen-component.js
function live_board_screen_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_screen_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_screen_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function live_board_screen_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function live_board_screen_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        live_board_screen_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















var liveBoardScreenComponent = function(props) {
    var translate = props.translate, closeLiveBoard = props.closeLiveBoard, showLiveBoard = props.showLiveBoard, embeddedBoardLink = props.embeddedBoardLink, boardBannerText = props.boardBannerText, embeddedBoardTitle = props.embeddedBoardTitle, addSecondLiveBoardSignUpButton = props.addSecondLiveBoardSignUpButton, liveBoardToolTipText = props.liveBoardToolTipText;
    var ref = (0,react.useState)(false), shakerIsActive = ref[0], setIsActive = ref[1];
    var ref1 = (0,react.useState)(MAIN_TABLE_TAB_ID), currentTab = ref1[0], setCurrentTab = ref1[1];
    var LIVE_BOARD_BANNER_PLACEMENT = "live_board_banner_placement";
    var LIVE_BOARD_TOP_RIGHT_PLACEMENT = "live_board_top_right_placement";
    var LIVE_BOARD_TAB_LOCATION = "live_board_tab_placement";
    var TOOLTIP_DEFAULT_TEXT = "Start by adding a task";
    var startShaking = function(callback) {
        setIsActive(true);
        callback();
    };
    var shakeBanner = function() {
        startShaking(resetShaker);
    };
    var resetShaker = function() {
        setTimeout(function() {
            return setIsActive(false);
        }, 600);
    };
    var onTabClick = function(index) {
        var _tabs_index;
        setCurrentTab((_tabs_index = tabs[index]) === null || _tabs_index === void 0 ? void 0 : _tabs_index.tabID);
    };
    var onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(closeLiveBoard);
    var renderCloseIcon = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "live-board-close",
            onClick: closeLiveBoard,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            role: "button",
            "aria-label": translate("liveBoard.close"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_close/* default */.Z, {
                className: "close-icon"
            })
        });
    };
    var tabsRenderer = function() {
        var theme = props.theme;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, hideLabel = tab.hideLabel, image = tab.image, LiveBoardTabComponent = tab.liveBoardTabComponent, scrollVisible = tab.scrollVisible, componentProps = tab.componentProps;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                label: tabLabel,
                color: theme,
                useXSMLabels: true,
                tabIcon: image,
                tabsWithIcons: true,
                hideLabel: hideLabel,
                extraData: {
                    location: LIVE_BOARD_TAB_LOCATION
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("tab-component", {
                        "scroll-visible": scrollVisible
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveBoardTabComponent, live_board_screen_component_object_spread_props(live_board_screen_component_object_spread({
                        onCardClick: shakeBanner
                    }, componentProps), {
                        sharableLink: embeddedBoardLink,
                        tooltipText: liveBoardToolTipText || TOOLTIP_DEFAULT_TEXT
                    }))
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLiveBoardScreenComponent, {
        className: classnames_default()("live-board-screen", {
            "board-fully-visible": showLiveBoard
        }),
        children: [
            showLiveBoard && renderCloseIcon(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "live-board-content-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "right-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "banner-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shake_component/* default */.Z, {
                                isActive: shakerIsActive,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                                    buttonConfig: {
                                        buttonType: "Signup"
                                    },
                                    bannerCta: translate("signup.cta"),
                                    bannerText: boardBannerText,
                                    withCloseIcon: false,
                                    theme: segments_service/* BRAND_WORK_MANAGEMENT_PRIMARY_THEME_ID */.Qu,
                                    hideBanner: false,
                                    placement: LIVE_BOARD_BANNER_PLACEMENT,
                                    extraData: {
                                        live_board_tab_type: currentTab
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "board-title-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "title-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(title/* default */.Z, {
                                            title: embeddedBoardTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tag",
                                            children: translate("liveBoard.demoEnvironment")
                                        })
                                    ]
                                }),
                                addSecondLiveBoardSignUpButton && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "sign-up-button-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_button/* default */.Z, {
                                        extraData: {
                                            placement: LIVE_BOARD_TOP_RIGHT_PLACEMENT
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(board_views_tab/* default */.Z, {
                            fullSizeContent: true,
                            tabsRenderer: tabsRenderer,
                            onTabClick: onTabClick
                        })
                    ]
                })
            })
        ]
    });
};
liveBoardScreenComponent.defaultProps = default_props;
/* harmony default export */ var live_board_screen_component = ((0,generic_config_context/* withGenericConfig */.P)(liveBoardScreenComponent));

;// CONCATENATED MODULE: ./components/core/live-board-experience/live-board-modal.js







var liveBoardPopupModal = function(props) {
    var showLiveBoard = props.showLiveBoard, closeLiveBoard = props.closeLiveBoard, translate = props.translate, isPreview = props.isPreview, embeddedBoardLink = props.embeddedBoardLink, boardBannerText = props.boardBannerText, embeddedBoardTitle = props.embeddedBoardTitle, addSecondLiveBoardSignUpButton = props.addSecondLiveBoardSignUpButton, liveBoardToolTipText = props.liveBoardToolTipText;
    (0,react.useEffect)(function() {
        document.body.classList.toggle("fullscreen-board", showLiveBoard);
    }, [
        showLiveBoard
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StylesLiveBoardPopupModal, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            className: classnames_default()("live-board-modal", {
                "fullscreen-board": showLiveBoard
            }),
            overlayClassName: classnames_default()("live-board-modal-overlay", {
                "fullscreen-board": showLiveBoard
            }),
            bodyOpenClassName: "modal-open",
            isOpen: isPreview ? false : true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_screen_component, {
                translate: translate,
                closeLiveBoard: closeLiveBoard,
                showLiveBoard: showLiveBoard,
                embeddedBoardLink: embeddedBoardLink,
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            })
        })
    });
};
/* harmony default export */ var live_board_modal = ((0,generic_config_context/* withGenericConfig */.P)(liveBoardPopupModal));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-service.js + 30 modules
var base_header_service = __webpack_require__(86666);
// EXTERNAL MODULE: ./services/sales-enrichment/sales-enrichment-service.js
var sales_enrichment_service = __webpack_require__(29919);
// EXTERNAL MODULE: ./services/typeform/typeform-service.js
var typeform_service = __webpack_require__(15728);
// EXTERNAL MODULE: ./services/ab-tests/monetization-ab-tests-service.js + 2 modules
var monetization_ab_tests_service = __webpack_require__(46724);
// EXTERNAL MODULE: ./contexts/careers-context.js
var careers_context = __webpack_require__(17581);
;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/scroll-to-top.scss.js


var StyledScrollToTop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e44y95e0"
})("opacity:", function(param) {
    var isDisplayed = param.isDisplayed;
    return isDisplayed ? 1 : 0;
}, ";transition:transform 0.3s ease-in-out;position:fixed;cursor:", function(param) {
    var isDisplayed = param.isDisplayed;
    return isDisplayed ? "pointer" : "unset";
}, ";z-index:", z_index/* ALWAYS_ON_TOP */.OL, ";right:36px;bottom:36px;svg{height:60px;width:60px;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/default-props.js
/* harmony default export */ var scroll_to_top_default_props = ({});

;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/scroll-icon.js

var ScrollIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "50",
                fill: "#6161FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M50.7071 33.2929C50.3166 32.9024 49.6834 32.9024 49.2929 33.2929L42.9289 39.6569C42.5384 40.0474 42.5384 40.6805 42.9289 41.0711C43.3195 41.4616 43.9526 41.4616 44.3431 41.0711L50 35.4142L55.6569 41.0711C56.0474 41.4616 56.6805 41.4616 57.0711 41.0711C57.4616 40.6805 57.4616 40.0474 57.0711 39.6569L50.7071 33.2929ZM51 72L51 34L49 34L49 72L51 72Z",
                fill: "white"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/core-components/scroll-to-top/scroll-to-top.js





var DEFAULT_SCROLL_OFFSET_TO_DISPLAY = 100;
var ScrollToTop = function(param) {
    var _scrollOffsetToDisplay = param.scrollOffsetToDisplay, scrollOffsetToDisplay = _scrollOffsetToDisplay === void 0 ? DEFAULT_SCROLL_OFFSET_TO_DISPLAY : _scrollOffsetToDisplay;
    var ref = (0,react.useState)(false), isDisplayed = ref[0], setIsDisplayed = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            window.scrollY >= scrollOffsetToDisplay ? setIsDisplayed(true) : setIsDisplayed(false);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var onClick = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollToTop, {
        onClick: onClick,
        className: "scroll-to-top",
        isDisplayed: isDisplayed,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollIcon, {})
    });
};
/* harmony default export */ var scroll_to_top = (ScrollToTop);
ScrollToTop.defaultProps = scroll_to_top_default_props;

// EXTERNAL MODULE: ./constants/new-ab-tests.js
var new_ab_tests = __webpack_require__(60734);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
;// CONCATENATED MODULE: ./segments/desktop/core-components/sticky-header/sticky-header.scss.js



var StyledStickyHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e343pp00"
})("display:flex;flex-direction:column;align-items:flex-end;.circle{width:50px;height:50px;border-radius:50%;display:flex;align-items:center;justify-content:flex-start;margin:10px 0;cursor:pointer;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";overflow:hidden;transition:width 0.5s ease,border-radius 0.5s ease;box-shadow:0px 2px 20px rgba(0,0,0,0.1);.circle-text{opacity:0;transition:opacity 0.5s ease;white-space:nowrap;}.picture-component{display:flex;height:24px;img{margin-left:12px;margin-right:10px;transition:margin 0.5s ease;}}}.expanded-circle{width:160px;height:50px;border-radius:50px;background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";display:flex;align-items:center;justify-content:flex-start;margin:10px 0;cursor:pointer;overflow:hidden;transition:width 0.5s ease,border-radius 0.5s ease;box-shadow:0px 2px 20px rgba(0,0,0,0.1);.circle-text{display:flex;opacity:1;padding-right:10px;justify-content:center;flex:1;}.picture-component{display:flex;height:24px;img{margin-left:20px;}}}.circle:not(.expanded-circle){.circle-text{opacity:0;}img{margin-left:12px;}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/core-components/sticky-header/consts.js
var circlesData = [
    {
        id: "promise",
        label: "stickyHeader.Promise",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/menu/Promise_1.png"
    },
    {
        id: "platform",
        label: "stickyHeader.Platform",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/menu/Platform_1.png"
    },
    {
        id: "products",
        label: "stickyHeader.Products",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/menu/Products_1.png"
    },
    {
        id: "enterprise",
        label: "stickyHeader.Enterprise",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/menu/Enterprise_1.png"
    },
    {
        id: "customers",
        label: "stickyHeader.Customers",
        image: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/menu/Customers_1.png"
    }
];

;// CONCATENATED MODULE: ./segments/desktop/core-components/sticky-header/sticky-header.js










var StickyHeader = function(props) {
    var translate = props.translate, startShowingStickyHeader = props.startShowingStickyHeader;
    var ref = (0,react.useState)(null), activeCircle = ref[0], setActiveCircle = ref[1];
    var ref1 = (0,react.useState)(null), visibleCircle = ref1[0], setVisibleCircle = ref1[1];
    (0,react.useEffect)(function() {
        if (startShowingStickyHeader) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.STICKY_HEADER_IS_VISIBLE);
        }
        var handleScroll = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var visibleSection = circlesData.find(function(circle) {
                        return circle.id === entry.target.id;
                    });
                    if (visibleSection) {
                        setVisibleCircle(visibleSection.id);
                    }
                }
            });
        };
        var observer = new IntersectionObserver(handleScroll, {
            root: null,
            threshold: 0.5
        });
        circlesData.forEach(function(circle) {
            var target = document.getElementById(circle.id);
            if (target) {
                observer.observe(target);
            }
        });
        return function() {
            circlesData.forEach(function(circle) {
                var target = document.getElementById(circle.id);
                if (target) {
                    observer.unobserve(target);
                }
            });
        };
    }, [
        startShowingStickyHeader
    ]);
    var handleCircleClick = function(id) {
        var targetElement = document.getElementById(id);
        if (targetElement) {
            var elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = elementPosition - 100;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.STICKY_HEADER_CIRCLE_CLICKED, {
            info1: id
        });
        setActiveCircle(null);
    };
    var handleCircleHover = function(id) {
        setActiveCircle(id);
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.STICKY_HEADER_CIRCLE_HOVERED, {
            info1: id
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledStickyHeader, {
        children: circlesData.map(function(circle) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: activeCircle === circle.id ? "expanded-circle" : "circle",
                onMouseEnter: function() {
                    return handleCircleHover(circle.id);
                },
                onMouseLeave: function() {
                    return setActiveCircle(null);
                },
                onClick: function() {
                    return handleCircleClick(circle.id);
                },
                style: {
                    backgroundColor: visibleCircle === circle.id ? colors/* default */.Z[color_consts.BRAND_AND_WORK_MANAGEMENT_LIGHT_TINT_02] : colors/* default */.Z[color_consts.WHITE_COLOR_NAME]
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: circle.image
                    }),
                    activeCircle === circle.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "circle-text",
                        children: translate(circle.label)
                    })
                ]
            }, circle.id);
        })
    });
};
/* harmony default export */ var sticky_header = ((0,generic_config_context/* withGenericConfig */.P)(StickyHeader));

;// CONCATENATED MODULE: ./components/templates/base-template.js






function base_template_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function base_template_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                base_template_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                base_template_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function base_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function base_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            base_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function base_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function base_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        base_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








































var SCROLL_PERCENTAGE_THROTTLE_TIME = 1000; // Execute a method only once per THROTTLE_TIME
var SCROLL_PERCENTAGE_STEPS = 10;
var UTM_URL_TERM = "utm";
var BaseTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseTemplate);
    function BaseTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, BaseTemplate);
        var _this;
        _this = _super.call(this, props);
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "openLiveBoard", function(props) {
            _this.setState({
                showLiveBoard: true,
                showLiveBoardImage: false,
                liveBoardProps: props
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.LIVE_BOARD_OPENED);
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setIsFirstFoldVisible", function(state) {
            _this.setState({
                isFirstFoldVisible: state
            });
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setStartShowingStickyHeader", function(state) {
            _this.setState({
                startShowingStickyHeader: state
            });
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "closeLiveBoard", function() {
            _this.setState({
                showLiveBoard: false,
                showLiveBoardImage: true,
                liveBoardClosed: true
            });
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.LIVE_BOARD_CLOSED);
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "scrollingByPercentage", /*#__PURE__*/ base_template_async_to_generator(function() {
            var maxRecordedScrollPercentage, currentScrollPercentage, documentHeight, viewportHeight, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        maxRecordedScrollPercentage = _this1.state.maxRecordedScrollPercentage;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0,dom_utils_service.getScrollPercent)()
                        ];
                    case 2:
                        currentScrollPercentage = _state.sent();
                        return [
                            4,
                            (0,dom_utils_service.getDocumentFullHeight)()
                        ];
                    case 3:
                        documentHeight = _state.sent();
                        return [
                            4,
                            (0,dom_utils_service.getViewportHeight)()
                        ];
                    case 4:
                        viewportHeight = _state.sent();
                        if (currentScrollPercentage > maxRecordedScrollPercentage + SCROLL_PERCENTAGE_STEPS) {
                            _this1.setState({
                                maxRecordedScrollPercentage: currentScrollPercentage
                            });
                            (0,bigbrain_service.trackEvent)(bigbrain_event_types.PAGE_SCROLL_BY_PERCENTAGE, {
                                kind: parseInt(currentScrollPercentage),
                                info1: viewportHeight,
                                info2: documentHeight,
                                info3: _this1.pageLoadUnique //	for easily find the last event per page load
                            });
                        }
                        return [
                            3,
                            6
                        ];
                    case 5:
                        e = _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        }));
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setAbTestDebugCookieIfNeeded", function() {
            var asPath = _this.props.asPath;
            var abTestDebugParamValue = (0,url.getUrlParamValue)(asPath, new_ab_tests.DEBUG_AB_TEST_PARAM_NAME);
            if (abTestDebugParamValue) {
                (0,cookies_service/* setCookie */.d8)(cookies.WEBSITE_AB_TEST_DEBUG_COOKIE_NAME, abTestDebugParamValue, {
                    expires: 1 / 24 // 1 hour
                });
            }
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "setMultiProductsTestCookieIfNeeded", function() {
            var _props = _this.props, abTestVariants = _props.abTestVariants, perceptionSurveyTests = _props.perceptionSurveyTests;
            var perceptionSurveyTestsNames = perceptionSurveyTests === null || perceptionSurveyTests === void 0 ? void 0 : perceptionSurveyTests.map(function(test) {
                return test.testName;
            });
            var multiProductsTest = abTestVariants === null || abTestVariants === void 0 ? void 0 : abTestVariants.find(function(abTest) {
                return perceptionSurveyTestsNames === null || perceptionSurveyTestsNames === void 0 ? void 0 : perceptionSurveyTestsNames.includes(abTest.name);
            });
            if (multiProductsTest) {
                (0,cookies_service/* setCookie */.d8)(cookies.MULTI_PRODUCTS_TEST_COOKIE_NAME, JSON.stringify({
                    id: multiProductsTest.id,
                    variant: multiProductsTest.versionNum
                }), {
                    expires: 1 // 24 hours
                });
            }
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "translate", function(key) {
            var translations = _this.props.translations;
            return translations[key] || key;
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "translateWithParam", function(key, parameter1) {
            var translation = _this.translate(key);
            var templateString = translation.replace("%param1%", parameter1);
            return templateString;
        });
        base_template_define_property((0,_assert_this_initialized/* default */.Z)(_this), "translateOrTranslateWithParam", function(keyToTranslate) {
            if (!keyToTranslate) return null;
            if (typeof keyToTranslate === "object") {
                var key = keyToTranslate.key, param = keyToTranslate.param;
                return _this.translateWithParam(key, param);
            }
            return _this.translate(keyToTranslate);
        });
        _this.pageLoadUnique = (0,utils_service.getRandomInt)(100000000);
        _this.passiveIfSupported = (0,dom_utils_service.getPassiveIfSupported)();
        _this.scrollPercentageEvent = lodash_throttle_default()(_this.scrollingByPercentage, SCROLL_PERCENTAGE_THROTTLE_TIME, {
            leading: false,
            trailing: true
        });
        _this.state = {
            maxRecordedScrollPercentage: 0,
            showLiveBoard: false,
            showLiveBoardImage: true,
            isFirstFoldVisible: true,
            startShowingStickyHeader: false,
            liveBoardClosed: false,
            liveBoardProps: {}
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseTemplate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _window_location_href, _window_location, _window;
                var _props = this.props, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, persistantCookies = _props.persistantCookies, abTestVariants = _props.abTestVariants, isPricingPage = _props.isPricingPage, forcePricing = _props.forcePricing, isPreview = _props.isPreview, isV13PricingVersion = _props.isV13PricingVersion;
                window.addEventListener("scroll", this.scrollPercentageEvent, this.passiveIfSupported);
                saveCloudfrontViewerCountryCookie(cloudfrontViewerCountry);
                if ((_window = window) === null || _window === void 0 ? void 0 : (_window_location = _window.location) === null || _window_location === void 0 ? void 0 : (_window_location_href = _window_location.href) === null || _window_location_href === void 0 ? void 0 : _window_location_href.includes(UTM_URL_TERM)) {
                    (0,sales_enrichment_service/* StoreUTMDataForEnrichment */.GB)();
                }
                this.sendGenericAbTestEventIfNeeded();
                this.setAbTestDebugCookieIfNeeded();
                this.setMultiProductsTestCookieIfNeeded();
                if (isPricingPage && !isPreview && persistantCookies) {
                    (0,monetization_ab_tests_service/* enterV13TestIfNeeded */.p)(abTestVariants, persistantCookies, forcePricing, isV13PricingVersion);
                }
            }
        },
        {
            key: "sendGenericAbTestEventIfNeeded",
            value: function sendGenericAbTestEventIfNeeded() {
                var _props = this.props, abTestVariants = _props.abTestVariants, abTestExactEventName = _props.abTestExactEventName;
                var abTestVariant = (0,lp_ab_tests_service.getExactEventNameAbTestVariant)(abTestExactEventName, abTestVariants);
                if (abTestExactEventName && abTestVariant) {
                    // TODO: should move to head script (AbTestSplitEventScript) and remove this method. Right now it depended on initialization functions and 3rd party services that should also move to head script
                    (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).IN_PAGE_AB_TEST_EVENT_NAME, {
                        abTestName: abTestExactEventName,
                        abTestVariant: abTestVariant
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.scrollPercentageEvent, this.passiveIfSupported);
            }
        },
        {
            key: "render",
            value: function render() {
                var extractTypes = function extractTypes(data) {
                    return data === null || data === void 0 ? void 0 : data.map(function(item) {
                        return item.type;
                    });
                };
                var _props = this.props, children = _props.children, title = _props.title, description = _props.description, canonicalUrl = _props.canonicalUrl, asPath = _props.asPath, fontLazyLoad = _props.fontLazyLoad, showHeaderScripts = _props.showHeaderScripts, marketingTemplateBoardIds = _props.marketingTemplateBoardIds, showTrustpilotReviews = _props.showTrustpilotReviews, coupon = _props.coupon, extendTrialCookie = _props.extendTrialCookie, clusterId = _props.clusterId, pageProductId = _props.pageProductId, pageClusterId = _props.pageClusterId, pageSubClusterId = _props.pageSubClusterId, pageClusterConfig = _props.pageClusterConfig, subClusterId = _props.subClusterId, clusterIdSource = _props.clusterIdSource, subClusterIdSource = _props.subClusterIdSource, clusterConfig = _props.clusterConfig, isClusterMiniSitePage = _props.isClusterMiniSitePage, useProductMiniSiteConfig = _props.useProductMiniSiteConfig, localeId = _props.localeId, userSelectedLanguage = _props.userSelectedLanguage, overrideLanguages = _props.overrideLanguages, withFullstory = _props.withFullstory, fullstoryRecordingFrequency = _props.fullstoryRecordingFrequency, abTestVariants = _props.abTestVariants, abTestExactEventName = _props.abTestExactEventName, template = _props.template, useExpandingSignup = _props.useExpandingSignup, disableGTM = _props.disableGTM, isMobileOrTabletBrowser = _props.isMobileOrTabletBrowser, isMobileBrowser = _props.isMobileBrowser, isTypeformDisabled = _props.isTypeformDisabled, positions = _props.positions, perceptionSurveyTests = _props.perceptionSurveyTests, imagesLazyLoad = _props.imagesLazyLoad, noIndex = _props.noIndex, noFollow = _props.noFollow, gtmContainerId = _props.gtmContainerId, useSectionsMenu = _props.useSectionsMenu, isPreview = _props.isPreview, currency = _props.currency, cloudfrontViewerCountry = _props.cloudfrontViewerCountry, useNewTranslationsApi = _props.useNewTranslationsApi, enableHotjar = _props.enableHotjar, hotjarFinalDate = _props.hotjarFinalDate, pricingVersion = _props.pricingVersion, hasFreeTier = _props.hasFreeTier, hideBannerWithBackground = _props.hideBannerWithBackground, cookies = _props.cookies, persistantCookies = _props.persistantCookies, lazyImages = _props.lazyImages, grantedFeatures = _props.grantedFeatures, freeTierForcePrevent = _props.freeTierForcePrevent, skipClustersQuestion = _props.skipClustersQuestion, forcePricing = _props.forcePricing, forceCurrency = _props.forceCurrency, hasStudentPlan = _props.hasStudentPlan, facebookMetaOverride = _props.facebookMetaOverride, twitterMetaOverride = _props.twitterMetaOverride, enablePageUsageDurationTracking = _props.enablePageUsageDurationTracking, dynamicAssetParam = _props.dynamicAssetParam, activePagePath = _props.activePagePath, activeOriginalPagePath = _props.activeOriginalPagePath, localizedPages = _props.localizedPages, pageBackgroundColorName = _props.pageBackgroundColorName, is404Page = _props.is404Page, isPricingPage = _props.isPricingPage, testTypeformContactSales = _props.testTypeformContactSales, forceTypeformContactSalesExperience = _props.forceTypeformContactSalesExperience, sendToSignupWithProductPage = _props.sendToSignupWithProductPage, seoFAQ = _props.seoFAQ, addLiveBoardExperience = _props.addLiveBoardExperience, preloadFirstFoldImages = _props.preloadFirstFoldImages, contactSalesTestMode = _props.contactSalesTestMode, shouldGetSignupPrefetchedAssets = _props.shouldGetSignupPrefetchedAssets, signupDynamicAssetsLinks = _props.signupDynamicAssetsLinks, embeddedBoardLink = _props.embeddedBoardLink, forceProductSignup = _props.forceProductSignup, customHeadScript = _props.customHeadScript, customBodyScript = _props.customBodyScript, useNewTypeformUSVariant = _props.useNewTypeformUSVariant, isV13PricingVersion = _props.isV13PricingVersion, segments = _props.segments, isInContactSalesNoHeaderTest = _props.isInContactSalesNoHeaderTest, simulateContactSalesButtonInTheFooter = _props.simulateContactSalesButtonInTheFooter, simulateSwitcherForExistingUsers = _props.simulateSwitcherForExistingUsers, simulateGloveReturnFromSignupFeedback = _props.simulateGloveReturnFromSignupFeedback, simulateEnterpriseButtonInHeader = _props.simulateEnterpriseButtonInHeader, hideContactSalesInFooter = _props.hideContactSalesInFooter, excludeFromSignupTests = _props.excludeFromSignupTests, showScrollToTop = _props.showScrollToTop, withStickyHeader = _props.withStickyHeader, simulatePostSubmissionCXTest = _props.simulatePostSubmissionCXTest, useAdaBotInPage = _props.useAdaBotInPage;
                var _state = this.state, showLiveBoard = _state.showLiveBoard, showLiveBoardImage = _state.showLiveBoardImage, liveBoardClosed = _state.liveBoardClosed, liveBoardProps = _state.liveBoardProps, startShowingStickyHeader = _state.startShowingStickyHeader;
                var isSecondaryMenuNeeded = (0,base_header_service/* shouldRenderSecondaryMenu */.Y0)(isClusterMiniSitePage, pageClusterConfig, useProductMiniSiteConfig);
                var isInAdaBotTest = simulatePostSubmissionCXTest || (0,acquisition_ab_test_service.shouldOpenCXBot)(abTestVariants, true);
                var shouldRenderCxBot = useAdaBotInPage && isInAdaBotTest;
                var shouldGetTypeformPrefetchedAssets = (0,typeform_service/* shouldGetTypeformExperience */.ap)({
                    abTests: abTestVariants,
                    isTypeformDisabled: isTypeformDisabled,
                    cloudfrontViewerCountry: cloudfrontViewerCountry,
                    testTypeformContactSales: testTypeformContactSales,
                    forceTypeformContactSalesExperience: forceTypeformContactSalesExperience
                });
                var shouldUseGloveReturnFromSignupFeedback = function(abTests, sendBigBrainEvent) {
                    if ((0,general/* isServerSide */.s$)()) return false;
                    return (0,new_ab_tests_service.isInTestWithNewVariant)(new_ab_tests.GLOVE_RETURN_FROM_SIGNUP_FEEDBACK, abTests, sendBigBrainEvent);
                };
                var useGloveReturnFromSignupFeedback = simulateGloveReturnFromSignupFeedback || shouldUseGloveReturnFromSignupFeedback(abTestVariants, true);
                var prefetchTypeformAssetsProviderProps = {
                    cloudfrontViewerCountry: cloudfrontViewerCountry,
                    useNewTypeformUSVariant: useNewTypeformUSVariant,
                    abTests: abTestVariants
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(generic_config_context/* GenericConfigContext.Provider */.Z.Provider, {
                    value: {
                        localeId: localeId,
                        clusterId: clusterId,
                        pageProductId: pageProductId,
                        pageClusterId: pageClusterId,
                        pageSubClusterId: pageSubClusterId,
                        pageClusterConfig: pageClusterConfig,
                        subClusterId: subClusterId,
                        clusterConfig: clusterConfig,
                        isClusterMiniSitePage: isClusterMiniSitePage,
                        useProductMiniSiteConfig: useProductMiniSiteConfig,
                        userSelectedLanguage: userSelectedLanguage,
                        overrideLanguages: overrideLanguages,
                        useExpandingSignup: useExpandingSignup,
                        isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                        isMobileBrowser: isMobileBrowser,
                        imagesLazyLoad: imagesLazyLoad,
                        noIndex: noIndex,
                        noFollow: noFollow,
                        isPreview: isPreview,
                        hasFreeTier: hasFreeTier,
                        isTypeformDisabled: isTypeformDisabled,
                        positions: positions,
                        perceptionSurveyTests: perceptionSurveyTests,
                        pricingVersion: isPreview ? (pricing_versions_default()).DEFAULT_VERSION : pricingVersion,
                        cloudfrontViewerCountry: cloudfrontViewerCountry,
                        useNewTranslationsApi: useNewTranslationsApi,
                        lazyImages: lazyImages,
                        translate: this.translate,
                        translateWithParam: this.translateWithParam,
                        translateOrTranslateWithParam: this.translateOrTranslateWithParam,
                        hideBannerWithBackground: hideBannerWithBackground,
                        cookies: cookies,
                        persistantCookies: persistantCookies,
                        currency: currency,
                        grantedFeatures: grantedFeatures,
                        freeTierForcePrevent: freeTierForcePrevent,
                        forcePricing: forcePricing,
                        forceCurrency: forceCurrency,
                        hasStudentPlan: hasStudentPlan,
                        dynamicAssetParam: dynamicAssetParam,
                        activePagePath: activePagePath,
                        activeOriginalPagePath: activeOriginalPagePath,
                        useSectionsMenu: useSectionsMenu,
                        is404Page: is404Page,
                        isPricingPage: isPricingPage,
                        testTypeformContactSales: testTypeformContactSales,
                        forceTypeformContactSalesExperience: forceTypeformContactSalesExperience,
                        sendToSignupWithProductPage: sendToSignupWithProductPage,
                        isSecondaryMenuNeeded: isSecondaryMenuNeeded,
                        contactSalesTestMode: contactSalesTestMode,
                        addLiveBoardExperience: addLiveBoardExperience,
                        openLiveBoard: this.openLiveBoard,
                        showLiveBoardImage: showLiveBoardImage,
                        liveBoardClosed: liveBoardClosed,
                        forceProductSignup: forceProductSignup,
                        useNewTypeformUSVariant: useNewTypeformUSVariant,
                        isV13PricingVersion: isV13PricingVersion,
                        setIsFirstFoldVisible: this.setIsFirstFoldVisible,
                        setStartShowingStickyHeader: this.setStartShowingStickyHeader,
                        isInContactSalesNoHeaderTest: isInContactSalesNoHeaderTest,
                        simulateContactSalesButtonInTheFooter: simulateContactSalesButtonInTheFooter,
                        simulateSwitcherForExistingUsers: simulateSwitcherForExistingUsers,
                        simulateEnterpriseButtonInHeader: simulateEnterpriseButtonInHeader,
                        hideContactSalesInFooter: hideContactSalesInFooter,
                        excludeFromSignupTests: excludeFromSignupTests,
                        usdAdaBot: shouldRenderCxBot,
                        isInAdaBotTest: isInAdaBotTest
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_tests_context/* AbTestsContext.Provider */.s.Provider, {
                        value: {
                            abTestVariants: abTestVariants,
                            abTestExactEventName: abTestExactEventName
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(careers_context/* CareersProvider */.U, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                                condition: shouldGetSignupPrefetchedAssets,
                                wrapper: function(children) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(prefetch_signup_service/* PrefetchSignupAssetsProvider */.v, {
                                        signupDynamicAssetsLinks: signupDynamicAssetsLinks,
                                        children: children
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                                    condition: shouldGetTypeformPrefetchedAssets,
                                    wrapper: function(children) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchTypeformAssetsProvider, base_template_object_spread_props(base_template_object_spread({}, prefetchTypeformAssetsProviderProps), {
                                            children: children
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_react/* ConditionalWrapper */.M, {
                                        condition: addLiveBoardExperience,
                                        wrapper: function(children) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefetchLiveBoardAssetsProvider, {
                                                children: children
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_head, {
                                                    title: title,
                                                    description: description,
                                                    canonicalUrl: canonicalUrl,
                                                    seoFAQ: seoFAQ,
                                                    fontLazyLoad: fontLazyLoad,
                                                    template: template,
                                                    disableGTM: disableGTM,
                                                    gtmContainerId: gtmContainerId,
                                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                                    pagePath: asPath,
                                                    facebookMetaOverride: facebookMetaOverride,
                                                    twitterMetaOverride: twitterMetaOverride,
                                                    localizedPages: localizedPages,
                                                    shouldGetSignupPrefetchedAssets: shouldGetSignupPrefetchedAssets,
                                                    shouldGetTypeformPrefetchedAssets: shouldGetTypeformPrefetchedAssets,
                                                    useGloveReturnFromSignupFeedback: useGloveReturnFromSignupFeedback,
                                                    useAdaBot: shouldRenderCxBot,
                                                    addLiveBoardExperience: addLiveBoardExperience,
                                                    preloadFirstFoldImages: preloadFirstFoldImages
                                                }),
                                                showHeaderScripts && /*#__PURE__*/ (0,jsx_runtime.jsx)(header_scripts_component/* default */.Z, {
                                                    coupon: coupon,
                                                    extendTrialCookie: extendTrialCookie,
                                                    marketingTemplateBoardIds: marketingTemplateBoardIds,
                                                    clusterId: clusterId,
                                                    subClusterId: subClusterId,
                                                    clusterIdSource: clusterIdSource,
                                                    subClusterIdSource: subClusterIdSource,
                                                    localeId: localeId,
                                                    template: template,
                                                    skipClustersQuestion: skipClustersQuestion,
                                                    enablePageUsageDurationTracking: enablePageUsageDurationTracking,
                                                    customHeadScript: customHeadScript,
                                                    segmentsList: extractTypes(segments)
                                                }),
                                                showScrollToTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(scroll_to_top, {}),
                                                !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template_scss/* StyledAccessibilityWrapper */.NK, {
                                                    className: "accessibility-menu-wrapper",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bypass_block_menu/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template_scss/* StyledTemplateContentWrapper */.es, {
                                                    className: classnames_default()("template-content-wrapper", {
                                                        "with-background-color": !!pageBackgroundColorName
                                                    }),
                                                    children: [
                                                        children,
                                                        addLiveBoardExperience && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "live-board-popup-wrapper",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(live_board_modal, base_template_object_spread({
                                                                    showLiveBoard: showLiveBoard,
                                                                    closeLiveBoard: this.closeLiveBoard,
                                                                    translate: this.translate,
                                                                    openPeekToBoard: this.openPeekToBoard,
                                                                    closePeekToBoard: this.closePeekToBoard,
                                                                    embeddedBoardLink: embeddedBoardLink
                                                                }, liveBoardProps))
                                                            })
                                                        }),
                                                        withStickyHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template_scss/* StyledStickyHeaderWrapper */.CK, {
                                                            className: classnames_default()("sticky-header", {
                                                                "show-sticky-header": startShowingStickyHeader
                                                            }),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_header, {
                                                                startShowingStickyHeader: startShowingStickyHeader
                                                            })
                                                        })
                                                    ]
                                                }),
                                                showHeaderScripts && /*#__PURE__*/ (0,jsx_runtime.jsx)(body_scripts_component, {
                                                    withFullstory: withFullstory,
                                                    fullstoryRecordingFrequency: fullstoryRecordingFrequency,
                                                    showTrustpilotReviews: showTrustpilotReviews,
                                                    pagePath: asPath,
                                                    fontLazyLoad: fontLazyLoad,
                                                    template: template,
                                                    disableGTM: disableGTM,
                                                    gtmContainerId: gtmContainerId,
                                                    enableHotjar: enableHotjar,
                                                    hotjarFinalDate: hotjarFinalDate,
                                                    clusterId: clusterId,
                                                    hasFreeTier: hasFreeTier,
                                                    localeId: localeId,
                                                    subClusterId: subClusterId,
                                                    isMobileOrTabletBrowser: isMobileOrTabletBrowser,
                                                    is404Page: is404Page,
                                                    customBodyScript: customBodyScript,
                                                    useAdaBot: shouldRenderCxBot
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            }
        }
    ]);
    return BaseTemplate;
}(react.PureComponent);

BaseTemplate.defaultProps = {
    showHeaderScripts: true,
    withFullstory: false,
    useExpandingSignup: false,
    translations: {},
    isPreview: false,
    skipClustersQuestion: false
};


/***/ }),

/***/ 35015:
/***/ (function(module) {


var TEMPLATE_NAMES = {
    OnePagerAssetTemplate: "OnePagerAssetTemplate",
    OnePagerWithImageTemplate: "OnePagerWithImageTemplate",
    MobileOnePagerWithImageTemplate: "MobileOnePagerWithImageTemplate",
    OnePagerWithVideoTemplate: "OnePagerWithVideoTemplate",
    CompetitorTemplate: "CompetitorTemplate",
    LongTemplate: "LongTemplate",
    SegmentsTemplate: "SegmentsTemplate",
    FixedLongLpTemplate: "FixedLongLpTemplate",
    ArticleTemplate: "ArticleTemplate",
    DirectoryImagesTemplate: "DirectoryImagesTemplate",
    MultipleDirectoryImagesTemplate: "MultipleDirectoryImagesTemplate",
    DynamicTemplate: "DynamicTemplate",
    MobileDynamicTemplate: "MobileDynamicTemplate",
    DevelopersCenterTemplate: "DevelopersCenterTemplate",
    WelcomeNewJoinersTemplate: "WelcomeNewJoinersTemplate",
    RemoteWorkTemplate: "RemoteWorkTemplate"
};
var isFixedLpTemplate = function(template) {
    return template === TEMPLATE_NAMES.FixedLongLpTemplate || template === TEMPLATE_NAMES.DynamicTemplate;
};
module.exports = {
    TEMPLATE_NAMES: TEMPLATE_NAMES,
    isFixedLpTemplate: isFixedLpTemplate
};


/***/ }),

/***/ 17581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CareersProvider; },
/* harmony export */   "m": function() { return /* binding */ useFilters; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CareersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
var CareersProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), search = ref[0], setSearch = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), department = ref1[0], setDepartment = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), location = ref2[0], setLocation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), positionsPerLocation = ref3[0], setPositionsPerLocation = ref3[1];
    var updatePositionsPerLocation = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(positions) {
        var numberOfPositionsPerLocation = positions === null || positions === void 0 ? void 0 : positions.reduce(function(acc, param) {
            var location = param.location;
            acc[location.name] = (acc[location.name] || 0) + 1;
            return acc;
        }, {});
        setPositionsPerLocation(numberOfPositionsPerLocation);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CareersContext.Provider, {
        value: {
            search: search,
            setSearch: setSearch,
            department: department,
            setDepartment: setDepartment,
            location: location,
            setLocation: setLocation,
            updatePositionsPerLocation: updatePositionsPerLocation,
            positionsPerLocation: positionsPerLocation
        },
        children: children
    });
};
var useFilters = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(CareersContext);
};


/***/ }),

/***/ 20959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ board_views_tab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/tabs/tabs-component.js + 1 modules
var tabs_component = __webpack_require__(10873);
// EXTERNAL MODULE: ./components/core/tabs/tab/tab-component.js + 1 modules
var tab_component = __webpack_require__(20525);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.scss.js

var LINE_WIDTH = 4;
var LINE_WIDTH_STRING = "".concat(LINE_WIDTH, "px");
var componentStyles = new String(".board-views-tab-component{padding-top:60px;margin:auto;.tabs-component-wrapper{.tabs-component{.content{.asset-wrapper{min-height:350px;opacity:0;&.animation-active{opacity:1;-webkit-transition:opacity 1s ease;-moz-transition:opacity 1s ease;-o-transition:opacity 1s ease;transition:opacity 1s ease}}}}.tab-component{.tab-underline-placeholder{height:0px}&.active{background-color:unset;.tab-underline-placeholder{height:".concat(LINE_WIDTH_STRING, "}}}}.tabs-component-wrapper{&.full-size-content{.tabs-component{.content{width:100%;height:100%}}}}}"));
componentStyles.__hash = "b40de9e2347e1569";

// EXTERNAL MODULE: ./segments/desktop/core-components/board-views-tab/default-props.js
var default_props = __webpack_require__(2536);
;// CONCATENATED MODULE: ./segments/desktop/core-components/board-views-tab/board-views-tab.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var BoardViewsTab = function(props) {
    var distanceFromTop = props.distanceFromTop, activeTabId = props.activeTabId, fullSizeContent = props.fullSizeContent, tabsRenderer = props.tabsRenderer, onTabClick = props.onTabClick;
    var ref = (0,react.useState)(true), animationActive = ref[0], setAnimationActive = ref[1];
    var onTabClickCallBack = function(index) {
        setAnimationActive(false);
        setTimeout(function() {
            return setAnimationActive(true);
        }, 0);
        if (onTabClick) {
            onTabClick(index);
        }
    };
    var defaultTabsRenderer = function() {
        var tabs = props.tabs, theme = props.theme;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map(function(tab, index) {
            var tabLabel = tab.tabLabel, asset = tab.asset, tabId = tab.tabId, image = tab.image;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(tab_component/* default */.Z, {
                tabId: tabId,
                label: tabLabel,
                color: theme,
                useXSMLabels: true,
                tabIcon: image,
                tabsWithIcons: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("asset-wrapper", {
                        "animation-active": animationActive
                    }),
                    children: /*#__PURE__*/ (0,react.createElement)(asset_component/* default */.Z, _object_spread_props(_object_spread({}, asset), {
                        key: index
                    }))
                })
            }, index);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "jsx-".concat(componentStyles.__hash) + " " + "board-views-tab-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "jsx-".concat(componentStyles.__hash) + " " + (classnames_default()("tabs-component-wrapper", {
                    "full-size-content": fullSizeContent
                }) || ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_component/* default */.Z, {
                    onTabClick: onTabClickCallBack,
                    distanceFromTop: distanceFromTop,
                    activeTabId: activeTabId,
                    autoTransition: false,
                    role: "tabpanel",
                    children: tabsRenderer ? tabsRenderer() : defaultTabsRenderer()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                id: componentStyles.__hash,
                children: componentStyles
            })
        ]
    });
};
BoardViewsTab.defaultProps = default_props/* default */.Z;
/* harmony default export */ var board_views_tab = (BoardViewsTab);


/***/ }),

/***/ 2536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var styles_color_consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(273);

/* harmony default export */ __webpack_exports__["Z"] = ({
    theme: styles_color_consts__WEBPACK_IMPORTED_MODULE_0__.WORK_OS_IRIS_COLOR_NAME,
    tabs: [
        {
            tabLabel: "Main table",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Table.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Maintable_2.png",
                    alt: "Main table view"
                }
            }
        },
        {
            tabLabel: "Gantt",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Gantt.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Gantt_2.png",
                    alt: "Gantt view"
                }
            }
        },
        {
            tabLabel: "Kanban",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Kanban.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Kanban_2.png",
                    alt: "Kanban view"
                }
            }
        },
        {
            tabLabel: "Calendar",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Calendar.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/calender_2.png",
                    alt: "Calendar view"
                }
            }
        },
        {
            tabLabel: "Dashboard",
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Dashboard.png"
            },
            asset: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/view/Dashboard_2.png",
                    alt: "Dashboard view"
                }
            }
        }
    ]
});


/***/ }),

/***/ 24459:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    boardIdAndToken: "581657007-136aa9fd1bbac5c25f0cf5bac147d93d",
    tooltipText: "Try it out here",
    liveBoard: false
});


/***/ }),

/***/ 94598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmbeddedBoard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-component.js + 1 modules
var tooltip_component = __webpack_require__(31590);
// EXTERNAL MODULE: ./components/enhancements/tooltip/tooltip-constants.js
var tooltip_constants = __webpack_require__(24984);
// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./utils/url.js
var utils_url = __webpack_require__(8339);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.scss.js


var StyledEmbeddedBoard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esnye570"
})("width:100%;height:100%;display:flex;flex-direction:column;@keyframes tooltip-toggle{0%{transform:translateY(0);}25%{transform:translateY(-5px);}50%{transform:translateY(-10px);}75%{transform:translateY(-5px);}100%{transform:translateY(0);}}.tooltip-wrapper{display:flex;justify-content:center;bottom:60px;position:relative;animation-name:tooltip-toggle;animation-iteration-count:infinite;animation-timing-function:ease-in;animation-duration:1s;transition:bottom 3s linear;}.embedded-wrapper{border-radius:8px;-moz-border-radius:8px;overflow:hidden;border:", "1px solid ".concat(colors/* default.border-gray */.Z["border-gray"]), ";box-sizing:border-box;display:flex;flex-direction:column;height:100%;.embedded-board-top-frame{background-color:", colors/* default.riverstone */.Z.riverstone, ";height:48px;display:flex;cursor:default;justify-content:flex-end;.powered-by-wrapper{margin-right:16px;font-size:0.8125rem;line-height:22px;display:flex;align-items:center;.monday-logo-image{margin-left:8px;padding-top:6px;width:100px;}}}.board-iframe-content-wrapper{height:100%;width:100%;.board-iframe{height:100%;width:100%;border-width:0;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/embedded-board/default-props.js
var default_props = __webpack_require__(24459);
;// CONCATENATED MODULE: ./segments/desktop/core-components/embedded-board/embedded-board.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}












var IFRAME_CLASS_NAME = "board-iframe";
var FULL_STORY_EMBEDDED_PARAM = "fullstory";
var PLATFORM_REGION_PARAM_NAME = "r";
var IS_LIVE_BOARD_PLATFORM_PARAM = "live_board";
var EmbeddedBoard = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(EmbeddedBoard, PureComponent);
    var _super = (0,_create_super/* default */.Z)(EmbeddedBoard);
    function EmbeddedBoard(props) {
        (0,_class_call_check/* default */.Z)(this, EmbeddedBoard);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getBoardEmbeddedURL", function() {
            var _props = _this.props, sharableLink = _props.sharableLink, boardIdAndToken = _props.boardIdAndToken, isLiveBoard = _props.isLiveBoard;
            var boardIdAndTokenProp = boardIdAndToken; // Old prop support
            var region;
            if (sharableLink) {
                region = (0,utils_url.getUrlParamValue)(sharableLink, PLATFORM_REGION_PARAM_NAME);
                boardIdAndTokenProp = (0,utils_url.getLastPartOfUrl)(sharableLink);
            }
            var url = "https://view.monday.com/embed/".concat(boardIdAndTokenProp, "?hide_footer=true&allow_edit=true");
            if (region) {
                url = (0,utils_url.addParamToURL)(url, PLATFORM_REGION_PARAM_NAME, region);
            }
            if (isLiveBoard) {
                url = (0,utils_url.addParamToURL)(url, IS_LIVE_BOARD_PLATFORM_PARAM, "true");
            }
            return url;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getIframeUrl", function() {
            var url = _this.getBoardEmbeddedURL();
            var fullStoryActiveForPage = !!(0,cookies_service/* getCookie */.ej)(cookies.ALWAYS_FS);
            if (fullStoryActiveForPage) {
                url = (0,utils_url.addParamToURL)(url, FULL_STORY_EMBEDDED_PARAM, true);
            }
            return url;
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "blurAction", function() {
            if (document.getElementsByClassName(IFRAME_CLASS_NAME)[0] === document.activeElement) {
                var boardIdAndToken = _this.props.boardIdAndToken;
                BigBrain("track", bigbrain_event_types.EMBEDDED_BOARD_INITIAL_INTERACTION, {
                    info1: boardIdAndToken
                });
                _this.setState({
                    showTooltip: false
                });
                window.removeEventListener("blur", _this.blurAction);
            }
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "renderTooltipIfNeeded", function() {
            var showTooltip = _this.state.showTooltip;
            var tooltipText = _this.props.tooltipText;
            if (!showTooltip) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tooltip-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip_component/* default */.Z, {
                    theme: tooltip_constants.DARK_THEME,
                    children: tooltipText
                })
            });
        });
        _this.state = {
            showTooltip: !!props.tooltipText
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(EmbeddedBoard, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("blur", this.blurAction);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("blur", this.blurAction);
            }
        },
        {
            key: "render",
            value: function render() {
                var hideTopFrame = this.props.hideTopFrame;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmbeddedBoard, {
                    className: "embedded-board",
                    children: [
                        this.renderTooltipIfNeeded(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "embedded-wrapper",
                            children: [
                                !hideTopFrame && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "embedded-board-top-frame",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "powered-by-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Powered by"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                src: links/* MONDAY_LOGO_SMALL_SRC */.Vm0,
                                                className: "monday-logo-image"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "board-iframe-content-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        src: this.getIframeUrl(),
                                        className: IFRAME_CLASS_NAME
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return EmbeddedBoard;
}(react.PureComponent);

EmbeddedBoard.defaultProps = default_props/* default */.Z;


/***/ })

}]);